"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postH5CampaignTaskUpdateCampaignStatus = exports.getH5CampaignTaskSendEverydayPlayMessage = exports.getH5CampaignTaskSendEverydayPlayAmount = exports.postH5CampaignSaveMemberVerification = exports.postH5CampaignReduceCampaignPickNum = exports.postH5CampaignPick = exports.postH5CampaignMemberPlayAmount = exports.postH5CampaignLuckyCodeUse = exports.getH5CampaignGetWinnerList = exports.postH5CampaignGetPickNumOrderDetail = exports.getH5CampaignGetMemberPickCount = exports.getH5CampaignGetDrawingTubeContents = exports.getH5CampaignGetCopywriterContents = exports.postH5CampaignGetCampaignPickNum = exports.postH5CampaignGetCampaignExt = exports.postH5CampaignGetCampaign = exports.postH5CampaignFirstGetPlayAmount = exports.postH5CampaignCheckMemberVerification = exports.postH5CampaignCheckMemberSubscribe = exports.postH5CampaignAddPickNum = exports.postEbCampaignOfflineHotelCampaign = exports.getEbCampaignGetDownLuckyCodeLinkKey = exports.postEbCampaignGetCampaignRule = exports.postEbCampaignGetCampaignList = exports.getEbCampaignGetCampaignItemList = exports.getEbCampaignGetCampaignAndRuleCampaignId = exports.postEbCampaignGetCampaign = exports.getEbCampaignGetAllCampaignLuckyCode = exports.postEbCampaignEndActivity = exports.getEbCampaignDownLuckyCodeAsExcel = exports.getEbCampaignCheckPointLimit = exports.getEbCampaignCheckCampaignStatus = exports.postEbCampaignCampaignUpdate = exports.getEbCampaignCampaignStart = exports.getEbCampaignCampaignRow = exports.getEbCampaignCampaignRoundList = exports.postEbCampaignCampaignPrizeStockReduce = exports.postEbCampaignCampaignPrizeStockAdd = exports.getEbCampaignCampaignNameOptions = exports.getEbCampaignCampaignList = exports.postEbCampaignCampaignDelete = exports.postEbCampaignCampaignCreate = exports.postEbCampaignAddCampaignRule = exports.postApiCampaignGetUserPickNum = exports.postApiCampaignGetUserGiftAmount = exports.getApiCampaignGetCampaignPayCashDetails = exports.postApiCampaignGetCampaign = exports.postApiCampaignChangeCampingPayCash = exports.postApiCampaignCampaignPayCash = exports.postApiCampaignAddUserPick = void 0;
exports.getCCustomizeMemberCenterExistSignInMemberMenu = exports.postCCustomizeSnapshotTagGetArticleListByTagIds = exports.postCCustomizeSnapshotTagGetArticleCountByTagIds = exports.postCCustomizeSnapshotTagGetArticleArea = exports.postCCustomizeSnapshotLikeUserLike = exports.getCCustomizeSnapshotLikeGetUserLikeInfo = exports.getCCustomizeSnapshotLikeCheckUserLike = exports.postCBoardConfigQueryBoardConfig = exports.postCBoardQueryHomePageUrl = exports.postCBoardQueryHomePageConfigUrl = exports.postCBoardQueryHomePageConfig = exports.postCBoardQueryBoardConfig = exports.getCBoardMerchantBoardIsHide = exports.postCBoardListBoardInstanceProduct = exports.postCBoardGetComposeTemplate = exports.getCBoardGetBoardToCustomizeSnapshotId = exports.getCBoardGetBoardProductCityBoardInstanceId = exports.getCBoardGetBoardInstanceWxaBoardInstanceId = exports.getCBoardGetBoardInstanceBoardInstanceId = exports.getCBoardGetCommissionRangeBoardInstanceId = exports.getCGetCustomThemeGetBoardCustomThemeByHotelId = exports.postCEntityCharacterGetList = exports.postCCustomizeNosaleProductSave = exports.getCBoardGlobalMenuGet = exports.getBtgGetListBigImage = exports.postBoardStatisticsIndex = exports.postBoardTemplateSaveBoardTemplate = exports.getBoardTemplateListBoardTemplate = exports.postBoardTemplateDeleteBoardTemplate = exports.getBoardSlotListBoardSlotNewBoardTemplateId = exports.getBoardCustomizedListTicketProduct = exports.getBoardCustomizedListTicketHotelHotelIdCityCity = exports.getBoardCustomizedListTicketCityHotelId = exports.getBoardCustomizedGetIsShowCustomizedHotelId = exports.getApiMultichannelBoardGetBoardDetailBoardId = exports.postApiHotelInfoGetProductApplyHotelids = exports.getApiHotelInfoGetHotelMapi = exports.getApiHotelInfoGetHotel = exports.getApiCustomizeSnapshotHandleRestoreAddAppletAttentionItem = exports.getApiCustomizeSnapshotHandleReplaceCustomizeItemLinkForCode = exports.getApiCustomizeSnapshotHandleHandleMenuItemJsonLink = exports.getApiCustomizeSnapshotHandleHandleCustomizeItemLinkForCode = exports.getApiCustomizeSnapshotHandleCompareCustomizeItemLink = exports.getApiCustomizeSnapshotHandleAddAppletAttentionItem = exports.postActivityPageEnrollSubmit = exports.getActivityListRelationInfo = exports.postActivityAigcDesignSubmit = exports.postMisCampaignUploadSave = exports.postMisCampaignGetCampaignUser = exports.getMisCampaignGetCampaignByHotelId = void 0;
exports.getEbBoardAigcDrawAigcSink = exports.getDemo = exports.getCustomizeTemplateUpdateOrderTop = exports.putCustomizeTemplateUpdateOrder = exports.postCustomizeTemplateSaveCustomizeTemplate = exports.postCustomizeTemplateMisGetCustomizeTemplateList = exports.getCustomizeTemplateListCustomizeTemplate = exports.getCustomizeTemplateGetSaveCustomizeTemplateVmoCustomizeTemplateId = exports.getCustomizeTemplateGetCustomizeTemplateList = exports.deleteCustomizeTemplateDeleteCustomizeTemplate = exports.postCustomizeCleaningDataLinkedData = exports.getCustomizeClassificationListCustomizeClassification = exports.getCustomizeCategoryGetCustomizeCategoryRelationship = exports.getCustomizeCategoryGetCustomizeCategoryInfo = exports.getCommonJobInitCustomMenuAppletJupmLink = exports.getCommonJobDeleteOssImage = exports.postCScenicScenicUpdateScenicSpotClockLog = exports.postCScenicScenicSaveScenicSpotClockLog = exports.getCScenicScenicGetScenicSpotClockLogGif = exports.postCScenicScenicGetScenicSpotClockLog = exports.postCScenicScenicAddScenicSpotClockLogGif = exports.postCMultichannelBoardListBoardProduct = exports.getCMultichannelBoardGetBoardProductCityBoardInstanceId = exports.getCMultichannelBoardGetBoardInstanceAppletBoardInstanceId = exports.postCCustomizeSnapshotReceiveCoupon = exports.getCCustomizeSnapshotGetShareInfo = exports.postCCustomizeSnapshotGetProductSelect = exports.postCCustomizeSnapshotGetProductRecommend = exports.postCCustomizeSnapshotGetProductListByCity = exports.getCCustomizeSnapshotGetProductCityCustomizeSnapshotId = exports.getCCustomizeSnapshotGetProductCity = exports.getCCustomizeSnapshotGetPassCommissionRange = exports.getCCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId = exports.getCCustomizeSnapshotGetCustomizeSnapshotJson = exports.getCCustomizeSnapshotGetCustomizeSnapshotForRanking = exports.getCCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId = exports.getCCustomizeSnapshotGetCustomizeSnapshot = exports.postCCustomizeSnapshotGetCustomizeListHotelIdAndType = exports.postCCustomizeSnapshotGetCustomizeItemList = exports.postCCustomizeSnapshotGetComposePoster = exports.postCCustomizeSnapshotGetCommissionRangeList = exports.postCCustomizeSnapshotGetCityByLocation = exports.postCCustomizeSnapshotGetCityByHotelIds = exports.getCCustomizeSnapshotGetCalendarConfig = exports.getCCustomizeSnapshotArticleCityByHotel = exports.getCCustomizeSnapshotArticleCityByBrand = exports.postCCustomizeSnapshotArticleByIds = exports.getCCustomizeMemberCenterGetCustomizeMemberOrderConfig = exports.getCCustomizeMemberCenterGetCustomizeMemberCenterInfo = exports.getCCustomizeMemberCenterGetCustomizeMemberBannerList = void 0;
exports.getEbBoardGetBoardInstanceBoardInstanceId = exports.postEbBoardGetBoardIdByActivityId = exports.getEbBoardDownloadBoardStatistics = exports.deleteEbBoardDeleteBoardInstance = exports.postEbBoardBoardTransformByInstanceId = exports.postEbBoardBoardTransformByHotelIds = exports.postEbPcwebcmsSetPageDefault = exports.postEbPcwebcmsSavePage = exports.postEbPcwebcmsSaveNews = exports.getEbPcwebcmsGetPageList = exports.getEbPcwebcmsGetPageInfo = exports.getEbPcwebcmsGetNewsList = exports.getEbPcwebcmsGetNewsInfo = exports.postEbPcwebcmsDelPage = exports.postEbPcwebcmsDelNews = exports.postEbPcwebSetSort = exports.postEbPcwebSetOpen = exports.postEbPcwebSetFooterSort = exports.postEbPcwebSetFooterOpen = exports.postEbPcwebSaveWebsiteInfo = exports.postEbPcwebSaveNavInfo = exports.postEbPcwebSaveFooterInfo = exports.getEbPcwebGetWebsiteList = exports.getEbPcwebGetWebsiteInfo = exports.getEbPcwebGetNavList = exports.getEbPcwebGetFooterList = exports.postEbPcwebDelWebsite = exports.postEbPcwebDelNav = exports.postEbPcwebDelFooter = exports.postEbCustomizeItemImageSaveItemImageRelation = exports.postEbCustomizeItemImageGetItemImageStatistics = exports.postEbBtgSortBigImage = exports.getEbBtgGetListBigImage = exports.postEbBtgEditBigImage = exports.getEbBtgDelBigImage = exports.postEbBoardGlobalMenuSave = exports.getEbBoardGlobalMenuGetByCustomizeSnapshotIdOrDefault = exports.getEbBoardGlobalMenuGet = exports.postEbBoardAigcDrawSaveOssMarkUrl = exports.postEbBoardAigcDrawSave = exports.getEbBoardAigcDrawReadLegalStatement = exports.postEbBoardAigcDrawModelList = exports.getEbBoardAigcDrawGetImageList = exports.getEbBoardAigcDrawGetDrawTaskImageList = exports.getEbBoardAigcDrawGetDrawTaskDetail = exports.getEbBoardAigcDrawGetDrawStyleList = exports.getEbBoardAigcDrawGetDrawList = exports.getEbBoardAigcDrawGetDrawCaseList = exports.postEbBoardAigcDrawDesignSubmit = exports.getEbBoardAigcDrawConvertDrawImageUrlByOssUrl = void 0;
exports.postEbCustomizeSnapshotListCustomizeSnapshotAndProduct = exports.postEbCustomizeSnapshotListCustomizeSnapshot = exports.postEbCustomizeSnapshotHomepageRestoreDefaultSettingsCustomizeSnapshotId = exports.postEbCustomizeSnapshotGetPosterInfo = exports.getEbCustomizeSnapshotGetPilotHotelIds = exports.postEbCustomizeSnapshotGetPassProductListByHotelId = exports.getEbCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId = exports.postEbCustomizeSnapshotGetCustomizeSnapshotProductInfoByProductId = exports.getEbCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId = exports.getEbCustomizeSnapshotGetCustomizeSnapshotStatus = exports.getEbCustomizeSnapshotGetCustomizeSnapshot = exports.postEbCustomizeSnapshotGetCustomizeAiShareText = exports.getEbCustomizeSnapshotGetBindCustomizeSnapshotsByProductId = exports.postEbCustomizeSnapshotGetTicketSelectOptions = exports.deleteEbCustomizeSnapshotDeleteCustomizeSnapshot = exports.getEbCustomizeSnapshotCustomizeSnapshotsForTypeId = exports.postEbCustomizeSnapshotCustomizeSnapshotSortPage = exports.postEbCustomizeSnapshotAddProductToCustomizeSnapshots = exports.getEbCustomizeMemberCenterUpdateCustomizeMemberBannerStatus = exports.postEbCustomizeMemberCenterSortCustomizeMemberBanner = exports.postEbCustomizeMemberCenterSaveCustomizeMemberOrderConfig = exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterConf = exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterShareConf = exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterPriorityLevelsConf = exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterMenuConf = exports.postEbCustomizeMemberCenterSaveCustomizeMemberBannerConfig = exports.getEbCustomizeMemberCenterGetCustomizeMemberOrderConfig = exports.getEbCustomizeMemberCenterGetCustomizeMemberCenterInfo = exports.getEbCustomizeMemberCenterGetCustomizeMemberCenterPriorityLevels = exports.getEbCustomizeMemberCenterGetCustomizeMemberBannerList = exports.getEbCustomizeMemberCenterGetCustomizeMemberBannerDetail = exports.getEbCustomizeMemberCenterGetAllIconInfo = exports.getEbCustomizeMemberCenterDeleteCustomizeMemberBanner = exports.postEbSmsSellSendSms = exports.postEbCustomizeSnapshotTagSave = exports.postEbCustomizeSnapshotTagList = exports.postEbCustomizeSnapshotTagGetArticleCountByTagBrandId = exports.getEbCustomizeSnapshotTagGet = exports.postEbBoardConfigSaveBoardConfig = exports.postEbBoardConfigQueryBoardConfig = exports.postEbBoardSaveBoardHomePage = exports.postEbBoardSaveBoardInstance = exports.postEbBoardQueryBoardHomePage = exports.getEbBoardListBoardInstanceExist = exports.getEbBoardListBoardInstance = exports.getEbBoardListEbBoardByIdBoardInstanceId = exports.postEbBoardListEbBoard = exports.getEbBoardIsTransferCustomizeSnapshotBoardInstanceId = exports.getEbBoardIsOfflineBoardBoardInstanceId = exports.postEbBoardGetBoardStatistics = void 0;
exports.postMisCustomizeTemplatePermissionSaveTemplateHotelPermission = exports.getMisCustomizeTemplatePermissionGetNeedPayTemplateList = exports.getMisCustomizeSnapshotHandleRestoreHandleMenuJsonRecord = exports.getMisCustomizeSnapshotHandleRestoreHandleMenuJsonByDataUrl = exports.postMisCustomizeSnapshotHandleHandleMenuJsonByDataUrl = exports.getMisCustomizeSnapshotHandleGetDownloadMenuJsonRecordLinkKey = exports.getMisCustomizeSnapshotHandleDownloadMenuJsonRecord = exports.postMisBoardHomePageBatchSave = exports.getMemberRegisterGiftGetAllValidData = exports.postLotteryDrawUpdateCampaignLogApiResultById = exports.getLotteryDrawGetMemberCanPlayCampaignList = exports.getLotteryDrawGetExistActNum = exports.getLotteryDrawGetCampaignLogBySaleOrderDetailId = exports.getLotteryDrawGetCampaignInfo = exports.getLotteryDrawGetAvailableCheckOutCampaign = exports.getLotteryDrawGetAvailableCheckOutActId = exports.getLotteryDrawGetAvailableActIds = exports.getFont = exports.getEbScenicSpotAreaId = exports.getEbScenicCheckCustomizeSnapshotIdCustomizeSnapshotId = exports.getEbScenicAreaHotelId = exports.postEbMultichannelBoardSaveMultichannelBoard = exports.getEbMultichannelBoardGetBoardList = exports.getEbMultichannelBoardGetBoardDetailBoardId = exports.postEbMultichannelBoardDeleteXhsBoardProduct = exports.getEbMultichannelBoardDeleteBoardProduct = exports.deleteEbMultichannelBoardDeleteBoard = exports.postEbMultichannelBoardCleanXhsBoardProduct = exports.getEbHotelListHotel = exports.getEbHotelGetSelfHotelInfo = exports.getEbHotelDetailHotel = exports.getEbCustomizeSnapshotDataReplaceSurplusPrepaycardData = exports.getEbCustomizeSnapshotDataReplaceAllPrepaycardData = exports.getEbCustomizeSnapshotDataInitCreateDefaultHomepageDataHotelId = exports.getEbCustomizeSnapshotDataInitCreateDefaultHomepageData = exports.getEbCustomizeSnapshotDataGetData = exports.getEbCustomizeSnapshotDataCreateTemplateOverviewData = exports.getEbCustomizeSnapshotDataCreateSubgroupOverviewData = exports.getEbCustomizeSnapshotDataCreateOverviewData = exports.getEbCustomizeSnapshotDataCreateDefaultHomepageData = exports.postEbCustomizeSnapshotUpdateCustomizeSnapshotShowOnShangHu = exports.postEbCustomizeSnapshotSavePosterConfig = exports.getEbCustomizeSnapshotSaveCustomizeSnapshotType = exports.postEbCustomizeSnapshotSaveCustomizeSnapshot = exports.postEbCustomizeSnapshotRemoveProductFromCustomizeSnapshots = exports.postEbCustomizeSnapshotListVendorCustomizeSnapshot = exports.postEbCustomizeSnapshotListFwgj = exports.getEbCustomizeSnapshotListCustomizeSnapshotType = exports.getEbCustomizeSnapshotListCustomizeSnapshotInfo = exports.postEbCustomizeSnapshotListCustomizeSnapshotByBrand = void 0;
exports.getTestGetHotelConfigListTest = exports.getTestGetHotelAreaByHotelIdListTest = exports.postTestGetCurrentProductIdTickIdRelTest = exports.getTestGetCouponStockFromCache = exports.getTestGetCoupon = exports.postTestGetComposeTemplateOldTest = exports.postTestGetComposeTemplateNewTest = exports.getTestGetTicketProductIdByPrepayCardProductIdTest = exports.postTestDeliverCoupon = exports.postTestBoardInstanceToSnapshotTestBoardInstanceId = exports.postTestBoardInstanceToSnapshotByHotelTest = exports.getSystemIconListBoardSystemIcon = exports.postSmsSellSendSms = exports.postRoomActivityEbBoardSave = exports.postRoomActivityBoardGetRoomActivityTitleListByTitleType = exports.postRoomActivityBoardGetRoomActivityTitleList = exports.getRoomActivityBoardGet = exports.getProductInfoList = exports.getPcwebGetWebsiteInfo = exports.getPcwebGetPayInfo = exports.getPcwebGetPageInfo = exports.getPcwebGetNewsInfo = exports.getPcwebGetNavList = exports.postMisCustomizeTemplateUpdateTemplateNeedPay = exports.postMisCustomizeTemplateSaveTemplateHotelPermission = exports.postMisCustomThemeSave = exports.postMisCustomThemeList = exports.getMisCustomThemeGet = exports.getMisCustomThemeDelete = exports.postMisUpdateTemplateNeedPay = exports.postMisUpdateHomepageJson = exports.postMisSaveTemplateHotelPermission = exports.getMisMagicDrawModelTop = exports.postMisMagicDrawModelSort = exports.postMisMagicDrawModelSave = exports.getMisMagicDrawModelList = exports.getMisMagicDrawModelDetail = exports.getMisMagicDrawModelDelete = exports.postMisMagicDrawConfigSort = exports.postMisMagicDrawConfigList = exports.postMisMagicDrawConfigFilter = exports.postMisMagicDrawConfigDelete = exports.postMisMagicDrawConfigAddOrModify = exports.postMisMagicDrawCaseConfigSort = exports.postMisMagicDrawCaseConfigList = exports.postMisMagicDrawCaseConfigDelete = exports.postMisMagicDrawCaseConfigAddOrModify = exports.postMisEntityCharacterSave = exports.postMisEntityCharacterGetList = exports.getMisEntityCharacterDelete = void 0;
exports.postUploadUploadVideo = exports.getTestValidateHotelAndAppTest = exports.postTestUpdateHomepageJsonTest = exports.postTestTestCache03UpdateCity = exports.getTestTestCache03GetCity = exports.postTestTestCache03DeleteCity = exports.postTestTestCache02UpdateCity = exports.getTestTestCache02GetCity = exports.postTestTestCache02DeleteCity = exports.postTestTestCache01UpdateCity = exports.getTestTestCache01GetCity = exports.postTestTestCache01DeleteCity = exports.getTestTestCacheGetHotel = exports.getTestTestCacheGetDeliverConfig = exports.getTestTestApollo = exports.postTestReplaceProductSidTestCustomizeSnapshotId = exports.postTestMarketingCouponInfo = exports.postTestListProductCommissionTest = exports.postTestLinkedDataTest = exports.postTestGetTest2 = exports.getTestGetSprcialConfigTest = exports.getTestGetSelfHotelIdByBrandIdsTest = exports.getTestGetMisSwitchResultTest = void 0;
var config_1 = __importDefault(require("./config"));
//#endregion
//#region Functions
// board-api
// 1.0
// http://test5-bg-api-gateway.zhiketong.net[80]/board-api/swagger-ui.html
/**
 * 通过接口给员工增加抽奖机会
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignAddUserPick(body, header) {
    var url = "/board-api/APICampaign/addUserPick";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiCampaignAddUserPick = postApiCampaignAddUserPick;
/**
 * 中奖用户发送现金奖励
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignCampaignPayCash(body, header) {
    var url = "/board-api/APICampaign/campaignPayCash";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiCampaignCampaignPayCash = postApiCampaignCampaignPayCash;
/**
 * 通过接口绑定和解绑大转盘现金属性
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignChangeCampingPayCash(body, header) {
    var url = "/board-api/APICampaign/changeCampingPayCash";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiCampaignChangeCampingPayCash = postApiCampaignChangeCampingPayCash;
/**
 * 获取大转盘基础信息及链接
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignGetCampaign(query, header) {
    var url = "/board-api/APICampaign/getCampaign";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postApiCampaignGetCampaign = postApiCampaignGetCampaign;
/**
 * 通过抽奖记录id查询需要发奖明细
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCampaignGetCampaignPayCashDetails(query, header) {
    var url = "/board-api/APICampaign/getCampaignPayCashDetails";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCampaignGetCampaignPayCashDetails = getApiCampaignGetCampaignPayCashDetails;
/**
 * 激励活动获取员工所对应的大转盘活动应发奖励（现金、积分）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignGetUserGiftAmount(body, header) {
    var url = "/board-api/APICampaign/getUserGiftAmount";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiCampaignGetUserGiftAmount = postApiCampaignGetUserGiftAmount;
/**
 * 激励活动获取员工抽奖次数
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiCampaignGetUserPickNum(body, header) {
    var url = "/board-api/APICampaign/getUserPickNum";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiCampaignGetUserPickNum = postApiCampaignGetUserPickNum;
/**
 * 大转盘新增规则
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignAddCampaignRule(body, header) {
    var url = "/board-api/EbCampaign/addCampaignRule";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignAddCampaignRule = postEbCampaignAddCampaignRule;
/**
 * 大转盘活动新增
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignCampaignCreate(query, body, header) {
    var url = "/board-api/EbCampaign/campaignCreate";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCampaignCampaignCreate = postEbCampaignCampaignCreate;
/**
 * 大转盘活动删除
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignCampaignDelete(query, body, header) {
    var url = "/board-api/EbCampaign/campaignDelete";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCampaignCampaignDelete = postEbCampaignCampaignDelete;
/**
 * 大转盘活动列表(集团id自定义页面查询活动时必传)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCampaignList(query, header) {
    var url = "/board-api/EbCampaign/campaignList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCampaignList = getEbCampaignCampaignList;
/**
 * 大转盘活动信息-NameOptions
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCampaignNameOptions(query, header) {
    var url = "/board-api/EbCampaign/campaignNameOptions";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCampaignNameOptions = getEbCampaignCampaignNameOptions;
/**
 * 增加大转盘奖品数量接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignCampaignPrizeStockAdd(body, header) {
    var url = "/board-api/EbCampaign/campaignPrizeStockAdd";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignCampaignPrizeStockAdd = postEbCampaignCampaignPrizeStockAdd;
/**
 * 减少大转盘奖品数量接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignCampaignPrizeStockReduce(body, header) {
    var url = "/board-api/EbCampaign/campaignPrizeStockReduce";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignCampaignPrizeStockReduce = postEbCampaignCampaignPrizeStockReduce;
/**
 * 大转盘场次列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCampaignRoundList(query, header) {
    var url = "/board-api/EbCampaign/campaignRoundList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCampaignRoundList = getEbCampaignCampaignRoundList;
/**
 * 大转盘活动信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCampaignRow(query, header) {
    var url = "/board-api/EbCampaign/campaignRow";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCampaignRow = getEbCampaignCampaignRow;
/**
 * 大转盘活动开始
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCampaignStart(query, header) {
    var url = "/board-api/EbCampaign/campaignStart";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCampaignStart = getEbCampaignCampaignStart;
/**
 * 大转盘活动更新
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignCampaignUpdate(query, body, header) {
    var url = "/board-api/EbCampaign/campaignUpdate";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCampaignCampaignUpdate = postEbCampaignCampaignUpdate;
/**
 * 通过大转盘id判断活动是否属于有效期内
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCheckCampaignStatus(query, header) {
    var url = "/board-api/EbCampaign/checkCampaignStatus";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCheckCampaignStatus = getEbCampaignCheckCampaignStatus;
/**
 * 检查能否使用积分
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignCheckPointLimit(query, header) {
    var url = "/board-api/EbCampaign/checkPointLimit";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignCheckPointLimit = getEbCampaignCheckPointLimit;
/**
 * 下载大转盘活动抽奖码（异步下载）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignDownLuckyCodeAsExcel(query, header) {
    var url = "/board-api/EbCampaign/downLuckyCodeAsExcel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignDownLuckyCodeAsExcel = getEbCampaignDownLuckyCodeAsExcel;
/**
 * 结束活动接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignEndActivity(body, header) {
    var url = "/board-api/EbCampaign/endActivity";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignEndActivity = postEbCampaignEndActivity;
/**
 * 获取大转盘全部抽奖码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignGetAllCampaignLuckyCode(query, header) {
    var url = "/board-api/EbCampaign/getAllCampaignLuckyCode";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignGetAllCampaignLuckyCode = getEbCampaignGetAllCampaignLuckyCode;
/**
 * 获取大转盘
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignGetCampaign(body, header) {
    var url = "/board-api/EbCampaign/getCampaign";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignGetCampaign = postEbCampaignGetCampaign;
/**
 * 获取大转盘信息(包括类型)
 * @param campaignId campaignId
 * @param header The http request header parameters.
 */
function getEbCampaignGetCampaignAndRuleCampaignId(campaignId, header) {
    var url = "/board-api/EbCampaign/getCampaignAndRule/" + campaignId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCampaignGetCampaignAndRuleCampaignId = getEbCampaignGetCampaignAndRuleCampaignId;
/**
 * 获取大转盘奖品数据接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCampaignGetCampaignItemList(query, header) {
    var url = "/board-api/EbCampaign/getCampaignItemList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCampaignGetCampaignItemList = getEbCampaignGetCampaignItemList;
/**
 * 新大转盘活动列表(支持按类型、场景、名称、状态查询)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignGetCampaignList(body, header) {
    var url = "/board-api/EbCampaign/getCampaignList";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignGetCampaignList = postEbCampaignGetCampaignList;
/**
 * 大转盘获取规则
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignGetCampaignRule(body, header) {
    var url = "/board-api/EbCampaign/getCampaignRule";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignGetCampaignRule = postEbCampaignGetCampaignRule;
/**
 * 获取大转盘抽奖码异步下载结果
 * @param key key
 * @param header The http request header parameters.
 */
function getEbCampaignGetDownLuckyCodeLinkKey(key, header) {
    var url = "/board-api/EbCampaign/getDownLuckyCodeLink/" + key;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCampaignGetDownLuckyCodeLinkKey = getEbCampaignGetDownLuckyCodeLinkKey;
/**
 * 下线酒店暂停、进行中、未开始的活动
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCampaignOfflineHotelCampaign(body, header) {
    var url = "/board-api/EbCampaign/offlineHotelCampaign";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCampaignOfflineHotelCampaign = postEbCampaignOfflineHotelCampaign;
/**
 * 大转盘增加抽奖次数
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignAddPickNum(body, header) {
    var url = "/board-api/H5Campaign/addPickNum";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignAddPickNum = postH5CampaignAddPickNum;
/**
 * 判断用户是否在活动期间关注
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignCheckMemberSubscribe(body, header) {
    var url = "/board-api/H5Campaign/check/memberSubscribe";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignCheckMemberSubscribe = postH5CampaignCheckMemberSubscribe;
/**
 * 判断用户是否需要验证图形验证码，true需要、false不需要
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignCheckMemberVerification(body, header) {
    var url = "/board-api/H5Campaign/check/memberVerification";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignCheckMemberVerification = postH5CampaignCheckMemberVerification;
/**
 * 大转盘会员首次领取机会（每日抽奖活动）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignFirstGetPlayAmount(body, header) {
    var url = "/board-api/H5Campaign/firstGetPlayAmount";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignFirstGetPlayAmount = postH5CampaignFirstGetPlayAmount;
/**
 * 获取大转盘基础信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignGetCampaign(body, header) {
    var url = "/board-api/H5Campaign/getCampaign";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignGetCampaign = postH5CampaignGetCampaign;
/**
 * 大转盘获取落地页
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignGetCampaignExt(body, header) {
    var url = "/board-api/H5Campaign/getCampaignExt";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignGetCampaignExt = postH5CampaignGetCampaignExt;
/**
 * 大转盘获取可抽奖次数
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignGetCampaignPickNum(body, header) {
    var url = "/board-api/H5Campaign/getCampaignPickNum";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignGetCampaignPickNum = postH5CampaignGetCampaignPickNum;
/**
 * 获取翻卡领红包文案
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getH5CampaignGetCopywriterContents(query, header) {
    var url = "/board-api/H5Campaign/getCopywriterContents";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getH5CampaignGetCopywriterContents = getH5CampaignGetCopywriterContents;
/**
 * 获取抽签筒非中奖签文案
 * @param header The http request header parameters.
 */
function getH5CampaignGetDrawingTubeContents(header) {
    var url = "/board-api/H5Campaign/getDrawingTubeContents";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getH5CampaignGetDrawingTubeContents = getH5CampaignGetDrawingTubeContents;
/**
 * 获取用户已抽奖次数
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getH5CampaignGetMemberPickCount(query, header) {
    var url = "/board-api/H5Campaign/getMemberPickCount";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getH5CampaignGetMemberPickCount = getH5CampaignGetMemberPickCount;
/**
 * 大转盘获取订单信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignGetPickNumOrderDetail(body, header) {
    var url = "/board-api/H5Campaign/getPickNumOrderDetail";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignGetPickNumOrderDetail = postH5CampaignGetPickNumOrderDetail;
/**
 * 获取中奖数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getH5CampaignGetWinnerList(query, header) {
    var url = "/board-api/H5Campaign/getWinnerList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getH5CampaignGetWinnerList = getH5CampaignGetWinnerList;
/**
 * 使用抽奖码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignLuckyCodeUse(body, header) {
    var url = "/board-api/H5Campaign/luckyCode/use";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignLuckyCodeUse = postH5CampaignLuckyCodeUse;
/**
 * 大转盘会员的抽奖机会（每日抽奖活动）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignMemberPlayAmount(body, header) {
    var url = "/board-api/H5Campaign/memberPlayAmount";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignMemberPlayAmount = postH5CampaignMemberPlayAmount;
/**
 * C端大转盘抽奖接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignPick(body, header) {
    var url = "/board-api/H5Campaign/pick";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignPick = postH5CampaignPick;
/**
 * 大转盘减少可抽奖次数
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignReduceCampaignPickNum(body, header) {
    var url = "/board-api/H5Campaign/reduceCampaignPickNum";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignReduceCampaignPickNum = postH5CampaignReduceCampaignPickNum;
/**
 * 记录用户验证码的验证结果
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postH5CampaignSaveMemberVerification(body, header) {
    var url = "/board-api/H5Campaign/save/memberVerification";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postH5CampaignSaveMemberVerification = postH5CampaignSaveMemberVerification;
/**
 * 大转盘赠送会员抽奖机会（每日抽奖活动）
 * @param header The http request header parameters.
 */
function getH5CampaignTaskSendEverydayPlayAmount(header) {
    var url = "/board-api/H5Campaign/task/sendEverydayPlayAmount";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getH5CampaignTaskSendEverydayPlayAmount = getH5CampaignTaskSendEverydayPlayAmount;
/**
 * 大转盘每天抽奖提醒（每日抽奖活动）
 * @param header The http request header parameters.
 */
function getH5CampaignTaskSendEverydayPlayMessage(header) {
    var url = "/board-api/H5Campaign/task/sendEverydayPlayMessage";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getH5CampaignTaskSendEverydayPlayMessage = getH5CampaignTaskSendEverydayPlayMessage;
/**
 * 大转盘更新活动状态
 * @param header The http request header parameters.
 */
function postH5CampaignTaskUpdateCampaignStatus(header) {
    var url = "/board-api/H5Campaign/task/updateCampaignStatus";
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postH5CampaignTaskUpdateCampaignStatus = postH5CampaignTaskUpdateCampaignStatus;
/**
 * 获取有效的大转盘活动(payCash默认不传返回有效活动，payCash为0时返回非现金活动，1是现金活动，2积分活动)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCampaignGetCampaignByHotelId(query, header) {
    var url = "/board-api/MisCampaign/getCampaignByHotelId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCampaignGetCampaignByHotelId = getMisCampaignGetCampaignByHotelId;
/**
 * 获取最后一次导入员工数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCampaignGetCampaignUser(body, header) {
    var url = "/board-api/MisCampaign/getCampaignUser";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCampaignGetCampaignUser = postMisCampaignGetCampaignUser;
/**
 * 保存员工导入excel活动
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCampaignUploadSave(body, header) {
    var url = "/board-api/MisCampaign/upload/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCampaignUploadSave = postMisCampaignUploadSave;
/**
 * AIGC设计大赛页面报名
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postActivityAigcDesignSubmit(body, header) {
    var url = "/board-api/activity/aigc/design/submit";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postActivityAigcDesignSubmit = postActivityAigcDesignSubmit;
/**
 * 批量查询活动关联的海报或自定义页面信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getActivityListRelationInfo(query, header) {
    var url = "/board-api/activity/list_relation_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getActivityListRelationInfo = getActivityListRelationInfo;
/**
 * 设计大赛页面报名表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postActivityPageEnrollSubmit(body, header) {
    var url = "/board-api/activity/page/enroll/submit";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postActivityPageEnrollSubmit = postActivityPageEnrollSubmit;
/**
 * 自定义页面添加小程序引导关注组件
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleAddAppletAttentionItem(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/addAppletAttentionItem";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleAddAppletAttentionItem = getApiCustomizeSnapshotHandleAddAppletAttentionItem;
/**
 * 自定义页面匹配带链接组件数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleCompareCustomizeItemLink(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/compareCustomizeItemLink";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleCompareCustomizeItemLink = getApiCustomizeSnapshotHandleCompareCustomizeItemLink;
/**
 * 自定义页面匹配带链接处理（活码非安全链接清洗）（测试）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleHandleCustomizeItemLinkForCode(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/handleCustomizeItemLinkForCode";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleHandleCustomizeItemLinkForCode = getApiCustomizeSnapshotHandleHandleCustomizeItemLinkForCode;
/**
 * 全局菜单栏解析tab数据操作
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleHandleMenuItemJsonLink(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/handleMenuItemJsonLink";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleHandleMenuItemJsonLink = getApiCustomizeSnapshotHandleHandleMenuItemJsonLink;
/**
 * 自定义页面匹配带链接处理（活码非安全链接清洗）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleReplaceCustomizeItemLinkForCode(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/replaceCustomizeItemLinkForCode";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleReplaceCustomizeItemLinkForCode = getApiCustomizeSnapshotHandleReplaceCustomizeItemLinkForCode;
/**
 * 恢复方法（自定义页面添加小程序引导关注组件）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiCustomizeSnapshotHandleRestoreAddAppletAttentionItem(query, header) {
    var url = "/board-api/api/customize_snapshot_handle/restoreAddAppletAttentionItem";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiCustomizeSnapshotHandleRestoreAddAppletAttentionItem = getApiCustomizeSnapshotHandleRestoreAddAppletAttentionItem;
/**
 * 获取酒店详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiHotelInfoGetHotel(query, header) {
    var url = "/board-api/api/hotelInfo/get_hotel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiHotelInfoGetHotel = getApiHotelInfoGetHotel;
/**
 * 小程序获取酒店详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getApiHotelInfoGetHotelMapi(query, header) {
    var url = "/board-api/api/hotelInfo/get_hotel_mapi";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getApiHotelInfoGetHotelMapi = getApiHotelInfoGetHotelMapi;
/**
 * 获取产品适用酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postApiHotelInfoGetProductApplyHotelids(body, header) {
    var url = "/board-api/api/hotelInfo/get_product_apply_hotelids";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postApiHotelInfoGetProductApplyHotelids = postApiHotelInfoGetProductApplyHotelids;
/**
 * api获取多渠道聚合海报详情
 * @param boardId 海报id
 * @param header The http request header parameters.
 */
function getApiMultichannelBoardGetBoardDetailBoardId(boardId, header) {
    var url = "/board-api/api/multichannelBoard/get_board_detail/" + boardId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getApiMultichannelBoardGetBoardDetailBoardId = getApiMultichannelBoardGetBoardDetailBoardId;
/**
 * 获取是否开启定制商城
 * @param hotelId 酒店id
 * @param header The http request header parameters.
 */
function getBoardCustomizedGetIsShowCustomizedHotelId(hotelId, header) {
    var url = "/board-api/boardCustomized/getIsShowCustomized/" + hotelId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getBoardCustomizedGetIsShowCustomizedHotelId = getBoardCustomizedGetIsShowCustomizedHotelId;
/**
 * 获取所有共享酒店的城市列表
 * @param hotelId 酒店id
 * @param header The http request header parameters.
 */
function getBoardCustomizedListTicketCityHotelId(hotelId, header) {
    var url = "/board-api/boardCustomized/listTicketCity/" + hotelId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getBoardCustomizedListTicketCityHotelId = getBoardCustomizedListTicketCityHotelId;
/**
 * 获取该城市所有共享酒店列表
 * @param hotelId 酒店id
 * @param city 城市
 * @param header The http request header parameters.
 */
function getBoardCustomizedListTicketHotelHotelIdCityCity(hotelId, city, header) {
    var url = "/board-api/boardCustomized/listTicketHotel/" + hotelId + "/city/" + city;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getBoardCustomizedListTicketHotelHotelIdCityCity = getBoardCustomizedListTicketHotelHotelIdCityCity;
/**
 * 获取城市酒店产品列表，城市多个酒店或单个酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getBoardCustomizedListTicketProduct(query, header) {
    var url = "/board-api/boardCustomized/listTicketProduct";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getBoardCustomizedListTicketProduct = getBoardCustomizedListTicketProduct;
/**
 * 查询海报卡槽
 * @param newBoardTemplateId newBoardTemplateId
 * @param header The http request header parameters.
 */
function getBoardSlotListBoardSlotNewBoardTemplateId(newBoardTemplateId, header) {
    var url = "/board-api/boardSlot/listBoardSlot/" + newBoardTemplateId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getBoardSlotListBoardSlotNewBoardTemplateId = getBoardSlotListBoardSlotNewBoardTemplateId;
/**
 * 删除海报模版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postBoardTemplateDeleteBoardTemplate(body, header) {
    var url = "/board-api/boardTemplate/deleteBoardTemplate";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postBoardTemplateDeleteBoardTemplate = postBoardTemplateDeleteBoardTemplate;
/**
 * 查询海报模版
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getBoardTemplateListBoardTemplate(query, header) {
    var url = "/board-api/boardTemplate/listBoardTemplate";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getBoardTemplateListBoardTemplate = getBoardTemplateListBoardTemplate;
/**
 * 保存海报模版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postBoardTemplateSaveBoardTemplate(body, header) {
    var url = "/board-api/boardTemplate/saveBoardTemplate";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postBoardTemplateSaveBoardTemplate = postBoardTemplateSaveBoardTemplate;
/**
 * 聚合海报数据统计
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postBoardStatisticsIndex(body, header) {
    var url = "/board-api/board_statistics/index";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postBoardStatisticsIndex = postBoardStatisticsIndex;
/**
 * 首旅首页C端：取大图列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getBtgGetListBigImage(query, header) {
    var url = "/board-api/btg/getListBigImage";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getBtgGetListBigImage = getBtgGetListBigImage;
/**
 * 全局底部菜单栏数据详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCBoardGlobalMenuGet(query, header) {
    var url = "/board-api/c/boardGlobalMenu/get";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCBoardGlobalMenuGet = getCBoardGlobalMenuGet;
/**
 * BALA在售商品状态监测上报接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeNosaleProductSave(body, header) {
    var url = "/board-api/c/customize/nosale/product/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeNosaleProductSave = postCCustomizeNosaleProductSave;
/**
 * 获取自定义实体字符列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCEntityCharacterGetList(body, header) {
    var url = "/board-api/c/entity/character/getList";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCEntityCharacterGetList = postCEntityCharacterGetList;
/**
 * 根据酒店id获取店铺个性化配置接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCGetCustomThemeGetBoardCustomThemeByHotelId(query, header) {
    var url = "/board-api/c/get_custom_theme/getBoardCustomThemeByHotelId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCGetCustomThemeGetBoardCustomThemeByHotelId = getCGetCustomThemeGetBoardCustomThemeByHotelId;
/**
 * 获取海报奖励范围
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCBoardGetCommissionRangeBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/cBoard/getCommissionRange/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCBoardGetCommissionRangeBoardInstanceId = getCBoardGetCommissionRangeBoardInstanceId;
/**
 * c端获取海报详情
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCBoardGetBoardInstanceBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/cBoard/get_board_instance/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCBoardGetBoardInstanceBoardInstanceId = getCBoardGetBoardInstanceBoardInstanceId;
/**
 * 小程序获取海报详情
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCBoardGetBoardInstanceWxaBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/cBoard/get_board_instance_wxa/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCBoardGetBoardInstanceWxaBoardInstanceId = getCBoardGetBoardInstanceWxaBoardInstanceId;
/**
 * c端聚合海报城市筛选
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCBoardGetBoardProductCityBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/cBoard/get_board_product_city/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCBoardGetBoardProductCityBoardInstanceId = getCBoardGetBoardProductCityBoardInstanceId;
/**
 * 获取迁移后自定义页面id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCBoardGetBoardToCustomizeSnapshotId(query, header) {
    var url = "/board-api/cBoard/get_board_to_customizeSnapshotId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCBoardGetBoardToCustomizeSnapshotId = getCBoardGetBoardToCustomizeSnapshotId;
/**
 * 聚合页生成海报
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardGetComposeTemplate(query, body, header) {
    var url = "/board-api/cBoard/get_compose_template";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postCBoardGetComposeTemplate = postCBoardGetComposeTemplate;
/**
 * 聚合海报产品列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardListBoardInstanceProduct(body, header) {
    var url = "/board-api/cBoard/list_board_instance_product";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardListBoardInstanceProduct = postCBoardListBoardInstanceProduct;
/**
 * 是否隐藏商户版模板商城tab
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCBoardMerchantBoardIsHide(query, header) {
    var url = "/board-api/cBoard/merchant_board/is_hide";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCBoardMerchantBoardIsHide = getCBoardMerchantBoardIsHide;
/**
 * 查询商户页面相关的配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardQueryBoardConfig(body, header) {
    var url = "/board-api/cBoard/query_board_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardQueryBoardConfig = postCBoardQueryBoardConfig;
/**
 * 获取默认首页配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardQueryHomePageConfig(body, header) {
    var url = "/board-api/cBoard/query_home_page_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardQueryHomePageConfig = postCBoardQueryHomePageConfig;
/**
 * 获取默认首页配置-直接返回url
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardQueryHomePageConfigUrl(body, header) {
    var url = "/board-api/cBoard/query_home_page_config_url";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardQueryHomePageConfigUrl = postCBoardQueryHomePageConfigUrl;
/**
 * 获取默认首页地址
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardQueryHomePageUrl(body, header) {
    var url = "/board-api/cBoard/query_home_page_url";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardQueryHomePageUrl = postCBoardQueryHomePageUrl;
/**
 * 查询商户页面相关的配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCBoardConfigQueryBoardConfig(body, header) {
    var url = "/board-api/cBoardConfig/query_board_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCBoardConfigQueryBoardConfig = postCBoardConfigQueryBoardConfig;
/**
 * 检查用户点赞状态接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotLikeCheckUserLike(query, header) {
    var url = "/board-api/cCustomizeSnapshotLike/checkUserLike";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotLikeCheckUserLike = getCCustomizeSnapshotLikeCheckUserLike;
/**
 * 获取用户点赞信息接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotLikeGetUserLikeInfo(query, header) {
    var url = "/board-api/cCustomizeSnapshotLike/getUserLikeInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotLikeGetUserLikeInfo = getCCustomizeSnapshotLikeGetUserLikeInfo;
/**
 * 点赞/取消点赞接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotLikeUserLike(body, header) {
    var url = "/board-api/cCustomizeSnapshotLike/userLike";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotLikeUserLike = postCCustomizeSnapshotLikeUserLike;
/**
 * 获取标签下的城市接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotTagGetArticleArea(body, header) {
    var url = "/board-api/cCustomizeSnapshotTag/getArticleArea";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotTagGetArticleArea = postCCustomizeSnapshotTagGetArticleArea;
/**
 * 获取标签下的文章数量接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotTagGetArticleCountByTagIds(body, header) {
    var url = "/board-api/cCustomizeSnapshotTag/getArticleCountByTagIds";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotTagGetArticleCountByTagIds = postCCustomizeSnapshotTagGetArticleCountByTagIds;
/**
 * 获取标签下的文章列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotTagGetArticleListByTagIds(body, header) {
    var url = "/board-api/cCustomizeSnapshotTag/getArticleListByTagIds";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotTagGetArticleListByTagIds = postCCustomizeSnapshotTagGetArticleListByTagIds;
/**
 * 酒店会员中心是否配置签到菜单
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeMemberCenterExistSignInMemberMenu(query, header) {
    var url = "/board-api/c_customize_member_center/exist_sign_in_member_menu";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeMemberCenterExistSignInMemberMenu = getCCustomizeMemberCenterExistSignInMemberMenu;
/**
 * C端获取会员中心活动banner列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeMemberCenterGetCustomizeMemberBannerList(query, header) {
    var url = "/board-api/c_customize_member_center/get_customize_member_banner_list";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeMemberCenterGetCustomizeMemberBannerList = getCCustomizeMemberCenterGetCustomizeMemberBannerList;
/**
 * 获取酒店会员中心详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeMemberCenterGetCustomizeMemberCenterInfo(query, header) {
    var url = "/board-api/c_customize_member_center/get_customize_member_center_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeMemberCenterGetCustomizeMemberCenterInfo = getCCustomizeMemberCenterGetCustomizeMemberCenterInfo;
/**
 * C端获取会员中心活动订单入口配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeMemberCenterGetCustomizeMemberOrderConfig(query, header) {
    var url = "/board-api/c_customize_member_center/get_customize_member_order_config";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeMemberCenterGetCustomizeMemberOrderConfig = getCCustomizeMemberCenterGetCustomizeMemberOrderConfig;
/**
 * 获取文章ID对应的数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotArticleByIds(body, header) {
    var url = "/board-api/c_customize_snapshot/article_by_ids";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotArticleByIds = postCCustomizeSnapshotArticleByIds;
/**
 * 获取集团文章对应的地区
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotArticleCityByBrand(query, header) {
    var url = "/board-api/c_customize_snapshot/article_city_by_brand";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotArticleCityByBrand = getCCustomizeSnapshotArticleCityByBrand;
/**
 * 获取酒店文章对应的地区
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotArticleCityByHotel(query, header) {
    var url = "/board-api/c_customize_snapshot/article_city_by_hotel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotArticleCityByHotel = getCCustomizeSnapshotArticleCityByHotel;
/**
 * 获取自定义页面日历房配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetCalendarConfig(query, header) {
    var url = "/board-api/c_customize_snapshot/get_calendar_config";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetCalendarConfig = getCCustomizeSnapshotGetCalendarConfig;
/**
 * 获取多个酒店ID下的城市信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetCityByHotelIds(body, header) {
    var url = "/board-api/c_customize_snapshot/get_city_by_hotel_ids";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetCityByHotelIds = postCCustomizeSnapshotGetCityByHotelIds;
/**
 * getCityByLocation
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetCityByLocation(body, header) {
    var url = "/board-api/c_customize_snapshot/get_city_by_location";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetCityByLocation = postCCustomizeSnapshotGetCityByLocation;
/**
 * 获取自定义页面奖励范围列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetCommissionRangeList(body, header) {
    var url = "/board-api/c_customize_snapshot/get_commission_range_list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetCommissionRangeList = postCCustomizeSnapshotGetCommissionRangeList;
/**
 * 生成海报
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetComposePoster(query, body, header) {
    var url = "/board-api/c_customize_snapshot/get_compose_poster";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postCCustomizeSnapshotGetComposePoster = postCCustomizeSnapshotGetComposePoster;
/**
 * 获取自定义页面组件json信息列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetCustomizeItemList(body, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_item_list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetCustomizeItemList = postCCustomizeSnapshotGetCustomizeItemList;
/**
 * 通过酒店id和巴拉类型获取更新时间最靠后的自定义页面id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetCustomizeListHotelIdAndType(body, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_list_hotel_id_and_type";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetCustomizeListHotelIdAndType = postCCustomizeSnapshotGetCustomizeListHotelIdAndType;
/**
 * 获取自定义页面快照详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetCustomizeSnapshot(query, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_snapshot";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetCustomizeSnapshot = getCCustomizeSnapshotGetCustomizeSnapshot;
/**
 * 获取自定义页面快照详情Old
 * @param customizeSnapshotId 页面id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId(customizeSnapshotId, query, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_snapshot/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId = getCCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId;
/**
 * 商户版星光榜获取自定义页面接口（优先取营销活动，若没有则取618促销）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetCustomizeSnapshotForRanking(query, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_snapshot_for_ranking";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetCustomizeSnapshotForRanking = getCCustomizeSnapshotGetCustomizeSnapshotForRanking;
/**
 * 获取自定义页面json信息，仅json数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetCustomizeSnapshotJson(query, header) {
    var url = "/board-api/c_customize_snapshot/get_customize_snapshot_json";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetCustomizeSnapshotJson = getCCustomizeSnapshotGetCustomizeSnapshotJson;
/**
 * 获取自定页面首页id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId(query, header) {
    var url = "/board-api/c_customize_snapshot/get_default_homepage/customizedSnapshotId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId = getCCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId;
/**
 * 获取自定义页面奖励范围
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetPassCommissionRange(query, header) {
    var url = "/board-api/c_customize_snapshot/get_pass_commission_range";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetPassCommissionRange = getCCustomizeSnapshotGetPassCommissionRange;
/**
 * 获取页面下的商品所属酒店的城市信息new
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetProductCity(query, header) {
    var url = "/board-api/c_customize_snapshot/get_product_city";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetProductCity = getCCustomizeSnapshotGetProductCity;
/**
 * 获取页面下的商品所属酒店的城市信息
 * @param customizeSnapshotId 页面id
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetProductCityCustomizeSnapshotId(customizeSnapshotId, header) {
    var url = "/board-api/c_customize_snapshot/get_product_city/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCCustomizeSnapshotGetProductCityCustomizeSnapshotId = getCCustomizeSnapshotGetProductCityCustomizeSnapshotId;
/**
 * 聚合海报产品列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetProductListByCity(body, header) {
    var url = "/board-api/c_customize_snapshot/get_product_list_by_city";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetProductListByCity = postCCustomizeSnapshotGetProductListByCity;
/**
 * 推荐组件获取产品列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetProductRecommend(body, header) {
    var url = "/board-api/c_customize_snapshot/get_product_recommend";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetProductRecommend = postCCustomizeSnapshotGetProductRecommend;
/**
 * 根据城市id筛选产品列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotGetProductSelect(body, header) {
    var url = "/board-api/c_customize_snapshot/get_product_select";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotGetProductSelect = postCCustomizeSnapshotGetProductSelect;
/**
 * 获取自定义分享信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCCustomizeSnapshotGetShareInfo(query, header) {
    var url = "/board-api/c_customize_snapshot/get_share_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCCustomizeSnapshotGetShareInfo = getCCustomizeSnapshotGetShareInfo;
/**
 * C端领取优惠券
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCCustomizeSnapshotReceiveCoupon(body, header) {
    var url = "/board-api/c_customize_snapshot/receive_coupon";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCCustomizeSnapshotReceiveCoupon = postCCustomizeSnapshotReceiveCoupon;
/**
 * 抖音小程序获取海报详情
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCMultichannelBoardGetBoardInstanceAppletBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/c_multichannel_board/get_board_instance_applet/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCMultichannelBoardGetBoardInstanceAppletBoardInstanceId = getCMultichannelBoardGetBoardInstanceAppletBoardInstanceId;
/**
 * c端聚合海报城市筛选
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getCMultichannelBoardGetBoardProductCityBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/c_multichannel_board/get_board_product_city/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCMultichannelBoardGetBoardProductCityBoardInstanceId = getCMultichannelBoardGetBoardProductCityBoardInstanceId;
/**
 * 多渠道聚合海报产品列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCMultichannelBoardListBoardProduct(body, header) {
    var url = "/board-api/c_multichannel_board/list_board_product";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCMultichannelBoardListBoardProduct = postCMultichannelBoardListBoardProduct;
/**
 * C端上传打卡记录视频
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCScenicScenicAddScenicSpotClockLogGif(body, header) {
    var url = "/board-api/c_scenic/scenic/add_scenic_spot_clock_log_gif";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCScenicScenicAddScenicSpotClockLogGif = postCScenicScenicAddScenicSpotClockLogGif;
/**
 * C端获取打卡记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCScenicScenicGetScenicSpotClockLog(body, header) {
    var url = "/board-api/c_scenic/scenic/get_scenic_spot_clock_log";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCScenicScenicGetScenicSpotClockLog = postCScenicScenicGetScenicSpotClockLog;
/**
 * C端获取上传打卡记录视频
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCScenicScenicGetScenicSpotClockLogGif(query, header) {
    var url = "/board-api/c_scenic/scenic/get_scenic_spot_clock_log_gif";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCScenicScenicGetScenicSpotClockLogGif = getCScenicScenicGetScenicSpotClockLogGif;
/**
 * C端保存打卡记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCScenicScenicSaveScenicSpotClockLog(body, header) {
    var url = "/board-api/c_scenic/scenic/save_scenic_spot_clock_log";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCScenicScenicSaveScenicSpotClockLog = postCScenicScenicSaveScenicSpotClockLog;
/**
 * C端修改打卡记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCScenicScenicUpdateScenicSpotClockLog(body, header) {
    var url = "/board-api/c_scenic/scenic/update_scenic_spot_clock_log";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCScenicScenicUpdateScenicSpotClockLog = postCScenicScenicUpdateScenicSpotClockLog;
/**
 * 删除AIGC绘图生成图片任务接口（超过30天的图片删除）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCommonJobDeleteOssImage(query, header) {
    var url = "/board-api/common/job/deleteOssImage";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCommonJobDeleteOssImage = getCommonJobDeleteOssImage;
/**
 * 初始化会员中心自定义菜单小程序链接
 * @param header The http request header parameters.
 */
function getCommonJobInitCustomMenuAppletJupmLink(header) {
    var url = "/board-api/common/job/init_custom_menu_applet_jupm_link";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCommonJobInitCustomMenuAppletJupmLink = getCommonJobInitCustomMenuAppletJupmLink;
/**
 * 获取自定义模版分类列表详情
 * @param header The http request header parameters.
 */
function getCustomizeCategoryGetCustomizeCategoryInfo(header) {
    var url = "/board-api/customize_category/get_customize_category_info";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCustomizeCategoryGetCustomizeCategoryInfo = getCustomizeCategoryGetCustomizeCategoryInfo;
/**
 * 获取自定义模版分类关系
 * @param header The http request header parameters.
 */
function getCustomizeCategoryGetCustomizeCategoryRelationship(header) {
    var url = "/board-api/customize_category/get_customize_category_relationship";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCustomizeCategoryGetCustomizeCategoryRelationship = getCustomizeCategoryGetCustomizeCategoryRelationship;
/**
 * 获取自定义模版分类列表 (old)
 * @param header The http request header parameters.
 */
function getCustomizeClassificationListCustomizeClassification(header) {
    var url = "/board-api/customize_classification/list_customize_classification";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getCustomizeClassificationListCustomizeClassification = getCustomizeClassificationListCustomizeClassification;
/**
 * 清洗自定义页面链接数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCustomizeCleaningDataLinkedData(body, header) {
    var url = "/board-api/customize_cleaning_data/linked_data";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCustomizeCleaningDataLinkedData = postCustomizeCleaningDataLinkedData;
/**
 * 删除自定义模版接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function deleteCustomizeTemplateDeleteCustomizeTemplate(body, header) {
    var url = "/board-api/customize_template/delete_customize_template";
    return config_1.default.request({ url: url, method: 'delete', body: body, header: header, });
}
exports.deleteCustomizeTemplateDeleteCustomizeTemplate = deleteCustomizeTemplateDeleteCustomizeTemplate;
/**
 * 获取自定义模版列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCustomizeTemplateGetCustomizeTemplateList(query, header) {
    var url = "/board-api/customize_template/get_customize_template_list";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCustomizeTemplateGetCustomizeTemplateList = getCustomizeTemplateGetCustomizeTemplateList;
/**
 * 获取模版详情接口
 * @param customizeTemplateId customizeTemplateId
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCustomizeTemplateGetSaveCustomizeTemplateVmoCustomizeTemplateId(customizeTemplateId, query, header) {
    var url = "/board-api/customize_template/get_save_customize_template_vmo/" + customizeTemplateId;
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCustomizeTemplateGetSaveCustomizeTemplateVmoCustomizeTemplateId = getCustomizeTemplateGetSaveCustomizeTemplateVmoCustomizeTemplateId;
/**
 * 获取自定义模版列表接口 old
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCustomizeTemplateListCustomizeTemplate(query, header) {
    var url = "/board-api/customize_template/list_customize_template";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCustomizeTemplateListCustomizeTemplate = getCustomizeTemplateListCustomizeTemplate;
/**
 * MIS端-获取自定义模版列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCustomizeTemplateMisGetCustomizeTemplateList(body, header) {
    var url = "/board-api/customize_template/mis_get_customize_template_list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCustomizeTemplateMisGetCustomizeTemplateList = postCustomizeTemplateMisGetCustomizeTemplateList;
/**
 * 保存自定义模版接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postCustomizeTemplateSaveCustomizeTemplate(body, header) {
    var url = "/board-api/customize_template/save_customize_template";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postCustomizeTemplateSaveCustomizeTemplate = postCustomizeTemplateSaveCustomizeTemplate;
/**
 * 自定义模版排序接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function putCustomizeTemplateUpdateOrder(body, header) {
    var url = "/board-api/customize_template/update_order";
    return config_1.default.request({ url: url, method: 'put', body: body, header: header, });
}
exports.putCustomizeTemplateUpdateOrder = putCustomizeTemplateUpdateOrder;
/**
 * MIS自定义模版置顶接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getCustomizeTemplateUpdateOrderTop(query, header) {
    var url = "/board-api/customize_template/update_order_top";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getCustomizeTemplateUpdateOrderTop = getCustomizeTemplateUpdateOrderTop;
/**
 * demo
 * @param header The http request header parameters.
 */
function getDemo(header) {
    var url = "/board-api/demo";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getDemo = getDemo;
/**
 * AIGC订阅队列（队列订阅补偿用）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawAigcSink(query, header) {
    var url = "/board-api/eb/boardAigcDraw/aigcSink";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardAigcDrawAigcSink = getEbBoardAigcDrawAigcSink;
/**
 * 转换生成图片真实地址接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawConvertDrawImageUrlByOssUrl(query, header) {
    var url = "/board-api/eb/boardAigcDraw/convertDrawImageUrlByOssUrl";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardAigcDrawConvertDrawImageUrlByOssUrl = getEbBoardAigcDrawConvertDrawImageUrlByOssUrl;
/**
 * EB端AIGC设计大赛页面报名
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardAigcDrawDesignSubmit(body, header) {
    var url = "/board-api/eb/boardAigcDraw/design/submit";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardAigcDrawDesignSubmit = postEbBoardAigcDrawDesignSubmit;
/**
 * 获取优秀案例列表接口
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetDrawCaseList(header) {
    var url = "/board-api/eb/boardAigcDraw/getDrawCaseList";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardAigcDrawGetDrawCaseList = getEbBoardAigcDrawGetDrawCaseList;
/**
 * 获取主图列表接口
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetDrawList(header) {
    var url = "/board-api/eb/boardAigcDraw/getDrawList";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardAigcDrawGetDrawList = getEbBoardAigcDrawGetDrawList;
/**
 * 获取风格选择列表接口
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetDrawStyleList(header) {
    var url = "/board-api/eb/boardAigcDraw/getDrawStyleList";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardAigcDrawGetDrawStyleList = getEbBoardAigcDrawGetDrawStyleList;
/**
 * 获取绘图任务详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetDrawTaskDetail(query, header) {
    var url = "/board-api/eb/boardAigcDraw/getDrawTaskDetail";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardAigcDrawGetDrawTaskDetail = getEbBoardAigcDrawGetDrawTaskDetail;
/**
 * 获取绘图任务列表接口（一个月内的近十次）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetDrawTaskImageList(query, header) {
    var url = "/board-api/eb/boardAigcDraw/getDrawTaskImageList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardAigcDrawGetDrawTaskImageList = getEbBoardAigcDrawGetDrawTaskImageList;
/**
 * 获取图片列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawGetImageList(query, header) {
    var url = "/board-api/eb/boardAigcDraw/getImageList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardAigcDrawGetImageList = getEbBoardAigcDrawGetImageList;
/**
 * 获取模型水印图列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardAigcDrawModelList(body, header) {
    var url = "/board-api/eb/boardAigcDraw/model/list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardAigcDrawModelList = postEbBoardAigcDrawModelList;
/**
 * 法律声明阅读接口
 * @param header The http request header parameters.
 */
function getEbBoardAigcDrawReadLegalStatement(header) {
    var url = "/board-api/eb/boardAigcDraw/readLegalStatement";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardAigcDrawReadLegalStatement = getEbBoardAigcDrawReadLegalStatement;
/**
 * 保存接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardAigcDrawSave(body, header) {
    var url = "/board-api/eb/boardAigcDraw/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardAigcDrawSave = postEbBoardAigcDrawSave;
/**
 * EB获取水印合成图片接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardAigcDrawSaveOssMarkUrl(body, header) {
    var url = "/board-api/eb/boardAigcDraw/saveOssMarkUrl";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardAigcDrawSaveOssMarkUrl = postEbBoardAigcDrawSaveOssMarkUrl;
/**
 * 全局底部菜单栏数据详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardGlobalMenuGet(query, header) {
    var url = "/board-api/eb/boardGlobalMenu/get";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardGlobalMenuGet = getEbBoardGlobalMenuGet;
/**
 * 根据自定义页面ID获取详细菜单栏接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardGlobalMenuGetByCustomizeSnapshotIdOrDefault(query, header) {
    var url = "/board-api/eb/boardGlobalMenu/getByCustomizeSnapshotIdOrDefault";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardGlobalMenuGetByCustomizeSnapshotIdOrDefault = getEbBoardGlobalMenuGetByCustomizeSnapshotIdOrDefault;
/**
 * 保存全局底部菜单栏数据接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardGlobalMenuSave(body, header) {
    var url = "/board-api/eb/boardGlobalMenu/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardGlobalMenuSave = postEbBoardGlobalMenuSave;
/**
 * 首旅首页：删除大图
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBtgDelBigImage(query, header) {
    var url = "/board-api/eb/btg/delBigImage";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBtgDelBigImage = getEbBtgDelBigImage;
/**
 * 首旅首页：保存大图
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBtgEditBigImage(body, header) {
    var url = "/board-api/eb/btg/editBigImage";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBtgEditBigImage = postEbBtgEditBigImage;
/**
 * 首旅首页：取大图列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBtgGetListBigImage(query, header) {
    var url = "/board-api/eb/btg/getListBigImage";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBtgGetListBigImage = getEbBtgGetListBigImage;
/**
 * 首旅首页：设置大图排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBtgSortBigImage(body, header) {
    var url = "/board-api/eb/btg/sortBigImage";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBtgSortBigImage = postEbBtgSortBigImage;
/**
 * 获取组件图片pv、uv统计接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeItemImageGetItemImageStatistics(body, header) {
    var url = "/board-api/eb/customizeItemImage/getItemImageStatistics";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeItemImageGetItemImageStatistics = postEbCustomizeItemImageGetItemImageStatistics;
/**
 * 保存组件图片关系接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeItemImageSaveItemImageRelation(body, header) {
    var url = "/board-api/eb/customizeItemImage/saveItemImageRelation";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeItemImageSaveItemImageRelation = postEbCustomizeItemImageSaveItemImageRelation;
/**
 * eb尾部导航管理：删除导航
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebDelFooter(body, header) {
    var url = "/board-api/eb/pcweb/delFooter";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebDelFooter = postEbPcwebDelFooter;
/**
 * eb头部导航管理：删除导航
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebDelNav(body, header) {
    var url = "/board-api/eb/pcweb/delNav";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebDelNav = postEbPcwebDelNav;
/**
 * eb站点管理：删除站点
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebDelWebsite(body, header) {
    var url = "/board-api/eb/pcweb/delWebsite";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebDelWebsite = postEbPcwebDelWebsite;
/**
 * eb尾部导航管理：通过站点id获取导航列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebGetFooterList(query, header) {
    var url = "/board-api/eb/pcweb/getFooterList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebGetFooterList = getEbPcwebGetFooterList;
/**
 * eb头部导航管理：通过站点id获取导航列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebGetNavList(query, header) {
    var url = "/board-api/eb/pcweb/getNavList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebGetNavList = getEbPcwebGetNavList;
/**
 * eb站点管理：通过站点id获取对应的站点
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebGetWebsiteInfo(query, header) {
    var url = "/board-api/eb/pcweb/getWebsiteInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebGetWebsiteInfo = getEbPcwebGetWebsiteInfo;
/**
 * eb站点管理：获取当前商户站点列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebGetWebsiteList(query, header) {
    var url = "/board-api/eb/pcweb/getWebsiteList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebGetWebsiteList = getEbPcwebGetWebsiteList;
/**
 * eb尾部导航管理：添加、编辑导航信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSaveFooterInfo(body, header) {
    var url = "/board-api/eb/pcweb/saveFooterInfo";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSaveFooterInfo = postEbPcwebSaveFooterInfo;
/**
 * eb头部导航管理：添加、编辑导航信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSaveNavInfo(body, header) {
    var url = "/board-api/eb/pcweb/saveNavInfo";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSaveNavInfo = postEbPcwebSaveNavInfo;
/**
 * eb站点管理：添加、编辑站点信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSaveWebsiteInfo(body, header) {
    var url = "/board-api/eb/pcweb/saveWebsiteInfo";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSaveWebsiteInfo = postEbPcwebSaveWebsiteInfo;
/**
 * eb尾部导航管理：设定导航状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSetFooterOpen(body, header) {
    var url = "/board-api/eb/pcweb/setFooterOpen";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSetFooterOpen = postEbPcwebSetFooterOpen;
/**
 * eb尾部导航管理：设定排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSetFooterSort(body, header) {
    var url = "/board-api/eb/pcweb/setFooterSort";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSetFooterSort = postEbPcwebSetFooterSort;
/**
 * eb头部导航管理：设定导航状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSetOpen(body, header) {
    var url = "/board-api/eb/pcweb/setOpen";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSetOpen = postEbPcwebSetOpen;
/**
 * eb头部导航管理：设定排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebSetSort(body, header) {
    var url = "/board-api/eb/pcweb/setSort";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebSetSort = postEbPcwebSetSort;
/**
 * eb站点内容管理：删除新闻
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebcmsDelNews(body, header) {
    var url = "/board-api/eb/pcwebcms/delNews";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebcmsDelNews = postEbPcwebcmsDelNews;
/**
 * eb站点内容管理：删除页面
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebcmsDelPage(body, header) {
    var url = "/board-api/eb/pcwebcms/delPage";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebcmsDelPage = postEbPcwebcmsDelPage;
/**
 * eb站点内容管理：获取新闻详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebcmsGetNewsInfo(query, header) {
    var url = "/board-api/eb/pcwebcms/getNewsInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebcmsGetNewsInfo = getEbPcwebcmsGetNewsInfo;
/**
 * eb站点内容管理：获取新闻列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebcmsGetNewsList(query, header) {
    var url = "/board-api/eb/pcwebcms/getNewsList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebcmsGetNewsList = getEbPcwebcmsGetNewsList;
/**
 * eb站点内容管理：获取页面详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebcmsGetPageInfo(query, header) {
    var url = "/board-api/eb/pcwebcms/getPageInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebcmsGetPageInfo = getEbPcwebcmsGetPageInfo;
/**
 * eb站点内容管理：获取页面列表接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbPcwebcmsGetPageList(query, header) {
    var url = "/board-api/eb/pcwebcms/getPageList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbPcwebcmsGetPageList = getEbPcwebcmsGetPageList;
/**
 * eb站点内容管理：保存新闻
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebcmsSaveNews(body, header) {
    var url = "/board-api/eb/pcwebcms/saveNews";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebcmsSaveNews = postEbPcwebcmsSaveNews;
/**
 * eb站点内容管理：保存页面
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebcmsSavePage(body, header) {
    var url = "/board-api/eb/pcwebcms/savePage";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebcmsSavePage = postEbPcwebcmsSavePage;
/**
 * eb站点内容管理：设定默认站点
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbPcwebcmsSetPageDefault(body, header) {
    var url = "/board-api/eb/pcwebcms/setPageDefault";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbPcwebcmsSetPageDefault = postEbPcwebcmsSetPageDefault;
/**
 * 聚合海报迁移酒店维度
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardBoardTransformByHotelIds(body, header) {
    var url = "/board-api/ebBoard/boardTransformByHotelIds";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardBoardTransformByHotelIds = postEbBoardBoardTransformByHotelIds;
/**
 * 聚合海报迁移页面维度
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardBoardTransformByInstanceId(body, header) {
    var url = "/board-api/ebBoard/boardTransformByInstanceId";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardBoardTransformByInstanceId = postEbBoardBoardTransformByInstanceId;
/**
 * 删除聚合海报
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function deleteEbBoardDeleteBoardInstance(query, header) {
    var url = "/board-api/ebBoard/delete_board_instance";
    return config_1.default.request({ url: url, method: 'delete', query: query, header: header, });
}
exports.deleteEbBoardDeleteBoardInstance = deleteEbBoardDeleteBoardInstance;
/**
 * 聚合海报统计数据下载
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardDownloadBoardStatistics(query, header) {
    var url = "/board-api/ebBoard/download_board_statistics";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardDownloadBoardStatistics = getEbBoardDownloadBoardStatistics;
/**
 * 根据活动id获取海报id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postEbBoardGetBoardIdByActivityId(query, header) {
    var url = "/board-api/ebBoard/getBoardIdByActivityId";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postEbBoardGetBoardIdByActivityId = postEbBoardGetBoardIdByActivityId;
/**
 * eb端获取聚合海报详情
 * @param boardInstanceId 海报id
 * @param header The http request header parameters.
 */
function getEbBoardGetBoardInstanceBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/ebBoard/getBoardInstance/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardGetBoardInstanceBoardInstanceId = getEbBoardGetBoardInstanceBoardInstanceId;
/**
 * 查询聚合海报统计数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardGetBoardStatistics(body, header) {
    var url = "/board-api/ebBoard/get_board_statistics";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardGetBoardStatistics = postEbBoardGetBoardStatistics;
/**
 * 聚合海报是否下线
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getEbBoardIsOfflineBoardBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/ebBoard/isOfflineBoard/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardIsOfflineBoardBoardInstanceId = getEbBoardIsOfflineBoardBoardInstanceId;
/**
 * 是否已迁移自定义页面
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getEbBoardIsTransferCustomizeSnapshotBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/ebBoard/isTransferCustomizeSnapshot/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardIsTransferCustomizeSnapshotBoardInstanceId = getEbBoardIsTransferCustomizeSnapshotBoardInstanceId;
/**
 * eb获取聚合海报列表及模版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardListEbBoard(body, header) {
    var url = "/board-api/ebBoard/listEbBoard";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardListEbBoard = postEbBoardListEbBoard;
/**
 * 根据海报id获取产品的图片
 * @param boardInstanceId boardInstanceId
 * @param header The http request header parameters.
 */
function getEbBoardListEbBoardByIdBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/ebBoard/listEbBoardById/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbBoardListEbBoardByIdBoardInstanceId = getEbBoardListEbBoardByIdBoardInstanceId;
/**
 * eb端获取聚合海报列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardListBoardInstance(query, header) {
    var url = "/board-api/ebBoard/list_board_instance";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardListBoardInstance = getEbBoardListBoardInstance;
/**
 * 获取海报是否可用状态接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbBoardListBoardInstanceExist(query, header) {
    var url = "/board-api/ebBoard/list_board_instance_exist";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbBoardListBoardInstanceExist = getEbBoardListBoardInstanceExist;
/**
 * 查询默认首页配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardQueryBoardHomePage(body, header) {
    var url = "/board-api/ebBoard/query_board_home_page";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardQueryBoardHomePage = postEbBoardQueryBoardHomePage;
/**
 * eb端保存聚合海报接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardSaveBoardInstance(body, header) {
    var url = "/board-api/ebBoard/saveBoardInstance";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardSaveBoardInstance = postEbBoardSaveBoardInstance;
/**
 *  设置默认首页
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardSaveBoardHomePage(body, header) {
    var url = "/board-api/ebBoard/save_board_home_page";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardSaveBoardHomePage = postEbBoardSaveBoardHomePage;
/**
 * 查询商户页面相关的配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardConfigQueryBoardConfig(body, header) {
    var url = "/board-api/ebBoardConfig/query_board_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardConfigQueryBoardConfig = postEbBoardConfigQueryBoardConfig;
/**
 * 保存商户页面相关的配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbBoardConfigSaveBoardConfig(body, header) {
    var url = "/board-api/ebBoardConfig/save_board_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbBoardConfigSaveBoardConfig = postEbBoardConfigSaveBoardConfig;
/**
 * 自定义bala文章标签详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotTagGet(query, header) {
    var url = "/board-api/ebCustomizeSnapshotTag/get";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotTagGet = getEbCustomizeSnapshotTagGet;
/**
 * EB获取集团下的文章数量+名称接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotTagGetArticleCountByTagBrandId(body, header) {
    var url = "/board-api/ebCustomizeSnapshotTag/getArticleCountByTagBrandId";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotTagGetArticleCountByTagBrandId = postEbCustomizeSnapshotTagGetArticleCountByTagBrandId;
/**
 * 自定义bala文章标签列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotTagList(body, header) {
    var url = "/board-api/ebCustomizeSnapshotTag/list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotTagList = postEbCustomizeSnapshotTagList;
/**
 * 保存自定义bala文章标签接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotTagSave(body, header) {
    var url = "/board-api/ebCustomizeSnapshotTag/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotTagSave = postEbCustomizeSnapshotTagSave;
/**
 * 短信卖货商户版发送短信
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbSmsSellSendSms(body, header) {
    var url = "/board-api/ebSmsSell/sendSms";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbSmsSellSendSms = postEbSmsSellSendSms;
/**
 * 删除会员中心活动banner
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterDeleteCustomizeMemberBanner(query, header) {
    var url = "/board-api/eb_customize_member_center/delete_customize_member_banner";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterDeleteCustomizeMemberBanner = getEbCustomizeMemberCenterDeleteCustomizeMemberBanner;
/**
 * 获取会员中心全部icon
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetAllIconInfo(query, header) {
    var url = "/board-api/eb_customize_member_center/get_all_icon_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetAllIconInfo = getEbCustomizeMemberCenterGetAllIconInfo;
/**
 * 获取会员中心活动banner详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetCustomizeMemberBannerDetail(query, header) {
    var url = "/board-api/eb_customize_member_center/get_customize_member_banner_detail";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetCustomizeMemberBannerDetail = getEbCustomizeMemberCenterGetCustomizeMemberBannerDetail;
/**
 * 获取会员中心活动banner列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetCustomizeMemberBannerList(query, header) {
    var url = "/board-api/eb_customize_member_center/get_customize_member_banner_list";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetCustomizeMemberBannerList = getEbCustomizeMemberCenterGetCustomizeMemberBannerList;
/**
 * Eb获取会员中心优先等级配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetCustomizeMemberCenterPriorityLevels(query, header) {
    var url = "/board-api/eb_customize_member_center/get_customize_member_center/priority_levels";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetCustomizeMemberCenterPriorityLevels = getEbCustomizeMemberCenterGetCustomizeMemberCenterPriorityLevels;
/**
 * Eb获取酒店会员中心详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetCustomizeMemberCenterInfo(query, header) {
    var url = "/board-api/eb_customize_member_center/get_customize_member_center_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetCustomizeMemberCenterInfo = getEbCustomizeMemberCenterGetCustomizeMemberCenterInfo;
/**
 * 获取会员中心订单入口配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterGetCustomizeMemberOrderConfig(query, header) {
    var url = "/board-api/eb_customize_member_center/get_customize_member_order_config";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterGetCustomizeMemberOrderConfig = getEbCustomizeMemberCenterGetCustomizeMemberOrderConfig;
/**
 * 保存会员中心活动bannar配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberBannerConfig(body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_banner_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberBannerConfig = postEbCustomizeMemberCenterSaveCustomizeMemberBannerConfig;
/**
 * Eb保存酒店会员中心 菜单配置
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberCenterMenuConf(query, body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_center/menu_conf";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterMenuConf = postEbCustomizeMemberCenterSaveCustomizeMemberCenterMenuConf;
/**
 * Eb保存酒店会员中心 优先等级配置
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberCenterPriorityLevelsConf(query, body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_center/priority_levels_conf";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterPriorityLevelsConf = postEbCustomizeMemberCenterSaveCustomizeMemberCenterPriorityLevelsConf;
/**
 * Eb保存酒店会员中心 分享配置
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberCenterShareConf(query, body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_center/share_conf";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterShareConf = postEbCustomizeMemberCenterSaveCustomizeMemberCenterShareConf;
/**
 * Eb保存酒店会员中心详情
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberCenterConf(query, body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_center_conf";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberCenterConf = postEbCustomizeMemberCenterSaveCustomizeMemberCenterConf;
/**
 * 保存会员中心订单入口配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSaveCustomizeMemberOrderConfig(body, header) {
    var url = "/board-api/eb_customize_member_center/save_customize_member_order_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSaveCustomizeMemberOrderConfig = postEbCustomizeMemberCenterSaveCustomizeMemberOrderConfig;
/**
 * 排序会员中心活动banner
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeMemberCenterSortCustomizeMemberBanner(body, header) {
    var url = "/board-api/eb_customize_member_center/sort_customize_member_banner";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeMemberCenterSortCustomizeMemberBanner = postEbCustomizeMemberCenterSortCustomizeMemberBanner;
/**
 * 更改会员中心活动banner状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeMemberCenterUpdateCustomizeMemberBannerStatus(query, header) {
    var url = "/board-api/eb_customize_member_center/update_customize_member_banner_status";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeMemberCenterUpdateCustomizeMemberBannerStatus = getEbCustomizeMemberCenterUpdateCustomizeMemberBannerStatus;
/**
 * 添加产品到自定义页面
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotAddProductToCustomizeSnapshots(body, header) {
    var url = "/board-api/eb_customize_snapshot/add_product_to_customize_snapshots";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotAddProductToCustomizeSnapshots = postEbCustomizeSnapshotAddProductToCustomizeSnapshots;
/**
 * bala:设备排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotCustomizeSnapshotSortPage(body, header) {
    var url = "/board-api/eb_customize_snapshot/customize_snapshot/sort_page";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotCustomizeSnapshotSortPage = postEbCustomizeSnapshotCustomizeSnapshotSortPage;
/**
 * 页面类型下的页面列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotCustomizeSnapshotsForTypeId(query, header) {
    var url = "/board-api/eb_customize_snapshot/customize_snapshots_for_type_id";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotCustomizeSnapshotsForTypeId = getEbCustomizeSnapshotCustomizeSnapshotsForTypeId;
/**
 * 删除自定义页面快照
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function deleteEbCustomizeSnapshotDeleteCustomizeSnapshot(body, header) {
    var url = "/board-api/eb_customize_snapshot/delete_customize_snapshot";
    return config_1.default.request({ url: url, method: 'delete', body: body, header: header, });
}
exports.deleteEbCustomizeSnapshotDeleteCustomizeSnapshot = deleteEbCustomizeSnapshotDeleteCustomizeSnapshot;
/**
 * 获取商品选择组件筛选标签
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotGetTicketSelectOptions(body, header) {
    var url = "/board-api/eb_customize_snapshot/getTicketSelectOptions";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotGetTicketSelectOptions = postEbCustomizeSnapshotGetTicketSelectOptions;
/**
 * 获取产品绑定的自定义页面信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetBindCustomizeSnapshotsByProductId(query, header) {
    var url = "/board-api/eb_customize_snapshot/get_bind_customize_snapshots_by_product_id";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotGetBindCustomizeSnapshotsByProductId = getEbCustomizeSnapshotGetBindCustomizeSnapshotsByProductId;
/**
 * AI生成分享文案接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotGetCustomizeAiShareText(body, header) {
    var url = "/board-api/eb_customize_snapshot/get_customize_ai_share_text";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotGetCustomizeAiShareText = postEbCustomizeSnapshotGetCustomizeAiShareText;
/**
 * 获取自定义页面快照详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetCustomizeSnapshot(query, header) {
    var url = "/board-api/eb_customize_snapshot/get_customize_snapshot";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotGetCustomizeSnapshot = getEbCustomizeSnapshotGetCustomizeSnapshot;
/**
 * 获取自定义页面快照状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetCustomizeSnapshotStatus(query, header) {
    var url = "/board-api/eb_customize_snapshot/get_customize_snapshot/status";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotGetCustomizeSnapshotStatus = getEbCustomizeSnapshotGetCustomizeSnapshotStatus;
/**
 * 获取自定义页面快照详情Old
 * @param customizeSnapshotId 页面id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId(customizeSnapshotId, query, header) {
    var url = "/board-api/eb_customize_snapshot/get_customize_snapshot/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId = getEbCustomizeSnapshotGetCustomizeSnapshotCustomizeSnapshotId;
/**
 * 根据产品Id和类型获取产品信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotGetCustomizeSnapshotProductInfoByProductId(body, header) {
    var url = "/board-api/eb_customize_snapshot/get_customize_snapshot_product_info_by_product_id";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotGetCustomizeSnapshotProductInfoByProductId = postEbCustomizeSnapshotGetCustomizeSnapshotProductInfoByProductId;
/**
 * 获取自定页面首页id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId(query, header) {
    var url = "/board-api/eb_customize_snapshot/get_default_homepage/customizedSnapshotId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId = getEbCustomizeSnapshotGetDefaultHomepageCustomizedSnapshotId;
/**
 * 【仅自定义页面配置门票产品用】根据酒店ID获取产品列表，支持分页
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotGetPassProductListByHotelId(body, header) {
    var url = "/board-api/eb_customize_snapshot/get_pass_product_list_by_hotel_id";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotGetPassProductListByHotelId = postEbCustomizeSnapshotGetPassProductListByHotelId;
/**
 * 获取当前配置的试点酒店
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotGetPilotHotelIds(header) {
    var url = "/board-api/eb_customize_snapshot/get_pilot_hotelIds";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotGetPilotHotelIds = getEbCustomizeSnapshotGetPilotHotelIds;
/**
 * 获取自定页面海报详情
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotGetPosterInfo(body, header) {
    var url = "/board-api/eb_customize_snapshot/get_poster_info";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotGetPosterInfo = postEbCustomizeSnapshotGetPosterInfo;
/**
 * 首页恢复默认设置
 * @param customizeSnapshotId customizeSnapshotId
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotHomepageRestoreDefaultSettingsCustomizeSnapshotId(customizeSnapshotId, header) {
    var url = "/board-api/eb_customize_snapshot/homepage/restore_default_settings/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postEbCustomizeSnapshotHomepageRestoreDefaultSettingsCustomizeSnapshotId = postEbCustomizeSnapshotHomepageRestoreDefaultSettingsCustomizeSnapshotId;
/**
 * 自定页面列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotListCustomizeSnapshot(body, header) {
    var url = "/board-api/eb_customize_snapshot/list_customize_snapshot";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotListCustomizeSnapshot = postEbCustomizeSnapshotListCustomizeSnapshot;
/**
 * 自定页面列表,带产品
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotListCustomizeSnapshotAndProduct(body, header) {
    var url = "/board-api/eb_customize_snapshot/list_customize_snapshot_and_product";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotListCustomizeSnapshotAndProduct = postEbCustomizeSnapshotListCustomizeSnapshotAndProduct;
/**
 * 集团下自定页面列表（应用底部菜单栏）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotListCustomizeSnapshotByBrand(body, header) {
    var url = "/board-api/eb_customize_snapshot/list_customize_snapshot_by_brand";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotListCustomizeSnapshotByBrand = postEbCustomizeSnapshotListCustomizeSnapshotByBrand;
/**
 * 获取自定义页面状态集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotListCustomizeSnapshotInfo(query, header) {
    var url = "/board-api/eb_customize_snapshot/list_customize_snapshot_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotListCustomizeSnapshotInfo = getEbCustomizeSnapshotListCustomizeSnapshotInfo;
/**
 * 获取自定义页面类型列表
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotListCustomizeSnapshotType(header) {
    var url = "/board-api/eb_customize_snapshot/list_customize_snapshot_type";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotListCustomizeSnapshotType = getEbCustomizeSnapshotListCustomizeSnapshotType;
/**
 * 启用服务管家的页面的商户列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotListFwgj(body, header) {
    var url = "/board-api/eb_customize_snapshot/list_fwgj";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotListFwgj = postEbCustomizeSnapshotListFwgj;
/**
 * 商户版自定义页面列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotListVendorCustomizeSnapshot(body, header) {
    var url = "/board-api/eb_customize_snapshot/list_vendor_customize_snapshot";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotListVendorCustomizeSnapshot = postEbCustomizeSnapshotListVendorCustomizeSnapshot;
/**
 * 从自定义页面移除产品
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotRemoveProductFromCustomizeSnapshots(body, header) {
    var url = "/board-api/eb_customize_snapshot/remove_product_from_customize_snapshots";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotRemoveProductFromCustomizeSnapshots = postEbCustomizeSnapshotRemoveProductFromCustomizeSnapshots;
/**
 * 保存自定义页面快照
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotSaveCustomizeSnapshot(query, body, header) {
    var url = "/board-api/eb_customize_snapshot/save_customize_snapshot";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postEbCustomizeSnapshotSaveCustomizeSnapshot = postEbCustomizeSnapshotSaveCustomizeSnapshot;
/**
 * 保存自定义页面类型
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotSaveCustomizeSnapshotType(query, header) {
    var url = "/board-api/eb_customize_snapshot/save_customize_snapshot_type";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotSaveCustomizeSnapshotType = getEbCustomizeSnapshotSaveCustomizeSnapshotType;
/**
 * 保存自定海报配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotSavePosterConfig(body, header) {
    var url = "/board-api/eb_customize_snapshot/save_poster_config";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotSavePosterConfig = postEbCustomizeSnapshotSavePosterConfig;
/**
 * 自定义列表，开启或关闭商户版展示
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbCustomizeSnapshotUpdateCustomizeSnapshotShowOnShangHu(body, header) {
    var url = "/board-api/eb_customize_snapshot/update_customize_snapshot/show_on_shangHu";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbCustomizeSnapshotUpdateCustomizeSnapshotShowOnShangHu = postEbCustomizeSnapshotUpdateCustomizeSnapshotShowOnShangHu;
/**
 * 创建的酒店创建默认首页
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataCreateDefaultHomepageData(header) {
    var url = "/board-api/eb_customize_snapshot_data/create_default_homepage_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataCreateDefaultHomepageData = getEbCustomizeSnapshotDataCreateDefaultHomepageData;
/**
 * 创建自定义页面数据概览数据
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataCreateOverviewData(header) {
    var url = "/board-api/eb_customize_snapshot_data/create_overview_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataCreateOverviewData = getEbCustomizeSnapshotDataCreateOverviewData;
/**
 * 创建自定义页面数据概览数据
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataCreateSubgroupOverviewData(header) {
    var url = "/board-api/eb_customize_snapshot_data/create_subgroup_overview_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataCreateSubgroupOverviewData = getEbCustomizeSnapshotDataCreateSubgroupOverviewData;
/**
 * 创建自定义页面数据概览数据
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataCreateTemplateOverviewData(header) {
    var url = "/board-api/eb_customize_snapshot_data/create_template_overview_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataCreateTemplateOverviewData = getEbCustomizeSnapshotDataCreateTemplateOverviewData;
/**
 * 自定义页面获取数据概览
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataGetData(header) {
    var url = "/board-api/eb_customize_snapshot_data/get_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataGetData = getEbCustomizeSnapshotDataGetData;
/**
 * 初始化为所有酒店创建默认首页
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataInitCreateDefaultHomepageData(header) {
    var url = "/board-api/eb_customize_snapshot_data/init_create_default_homepage_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbCustomizeSnapshotDataInitCreateDefaultHomepageData = getEbCustomizeSnapshotDataInitCreateDefaultHomepageData;
/**
 * 初始化指定酒店创建默认首页
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataInitCreateDefaultHomepageDataHotelId(query, header) {
    var url = "/board-api/eb_customize_snapshot_data/init_create_default_homepage_data_hotelId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotDataInitCreateDefaultHomepageDataHotelId = getEbCustomizeSnapshotDataInitCreateDefaultHomepageDataHotelId;
/**
 * 全量替换 储值卡数据id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataReplaceAllPrepaycardData(query, header) {
    var url = "/board-api/eb_customize_snapshot_data/replace_all_prepaycard_data";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotDataReplaceAllPrepaycardData = getEbCustomizeSnapshotDataReplaceAllPrepaycardData;
/**
 * 遗漏数据 替换储值卡数据id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbCustomizeSnapshotDataReplaceSurplusPrepaycardData(query, header) {
    var url = "/board-api/eb_customize_snapshot_data/replace_surplus_prepaycard_data";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbCustomizeSnapshotDataReplaceSurplusPrepaycardData = getEbCustomizeSnapshotDataReplaceSurplusPrepaycardData;
/**
 * 商户详细信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbHotelDetailHotel(query, header) {
    var url = "/board-api/eb_hotel/detail_hotel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbHotelDetailHotel = getEbHotelDetailHotel;
/**
 * 获取集团下主店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbHotelGetSelfHotelInfo(query, header) {
    var url = "/board-api/eb_hotel/get_self_hotel_info";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbHotelGetSelfHotelInfo = getEbHotelGetSelfHotelInfo;
/**
 * 集团下商户列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbHotelListHotel(query, header) {
    var url = "/board-api/eb_hotel/list_hotel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbHotelListHotel = getEbHotelListHotel;
/**
 * 清洗小红书模板中已经下线的商品,一次性工具，用完删除
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbMultichannelBoardCleanXhsBoardProduct(body, header) {
    var url = "/board-api/eb_multichannel_board/clean_xhs_board_product";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbMultichannelBoardCleanXhsBoardProduct = postEbMultichannelBoardCleanXhsBoardProduct;
/**
 * 删除聚合海报
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function deleteEbMultichannelBoardDeleteBoard(query, header) {
    var url = "/board-api/eb_multichannel_board/delete_board";
    return config_1.default.request({ url: url, method: 'delete', query: query, header: header, });
}
exports.deleteEbMultichannelBoardDeleteBoard = deleteEbMultichannelBoardDeleteBoard;
/**
 * 删除模版下的商品
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbMultichannelBoardDeleteBoardProduct(query, header) {
    var url = "/board-api/eb_multichannel_board/delete_board_product";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbMultichannelBoardDeleteBoardProduct = getEbMultichannelBoardDeleteBoardProduct;
/**
 * 删除小红书模板中的指定的商品
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbMultichannelBoardDeleteXhsBoardProduct(body, header) {
    var url = "/board-api/eb_multichannel_board/delete_xhs_board_product";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbMultichannelBoardDeleteXhsBoardProduct = postEbMultichannelBoardDeleteXhsBoardProduct;
/**
 * eb端获取多渠道聚合海报详情
 * @param boardId 海报id
 * @param header The http request header parameters.
 */
function getEbMultichannelBoardGetBoardDetailBoardId(boardId, header) {
    var url = "/board-api/eb_multichannel_board/get_board_detail/" + boardId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbMultichannelBoardGetBoardDetailBoardId = getEbMultichannelBoardGetBoardDetailBoardId;
/**
 * eb端获取多渠道聚合海报列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getEbMultichannelBoardGetBoardList(query, header) {
    var url = "/board-api/eb_multichannel_board/get_board_list";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getEbMultichannelBoardGetBoardList = getEbMultichannelBoardGetBoardList;
/**
 * eb端保存多渠道聚合海报接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postEbMultichannelBoardSaveMultichannelBoard(body, header) {
    var url = "/board-api/eb_multichannel_board/save_multichannel_board";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postEbMultichannelBoardSaveMultichannelBoard = postEbMultichannelBoardSaveMultichannelBoard;
/**
 * 获取酒店下所有景区信息
 * @param hotelId hotelId
 * @param header The http request header parameters.
 */
function getEbScenicAreaHotelId(hotelId, header) {
    var url = "/board-api/eb_scenic/area/" + hotelId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbScenicAreaHotelId = getEbScenicAreaHotelId;
/**
 * 景区景点配置balabalaId校验是否存在
 * @param customizeSnapshotId customizeSnapshotId
 * @param header The http request header parameters.
 */
function getEbScenicCheckCustomizeSnapshotIdCustomizeSnapshotId(customizeSnapshotId, header) {
    var url = "/board-api/eb_scenic/check_customize_snapshot_id/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbScenicCheckCustomizeSnapshotIdCustomizeSnapshotId = getEbScenicCheckCustomizeSnapshotIdCustomizeSnapshotId;
/**
 * 获取景区下所有景点信息 参数景区id
 * @param areaId areaId
 * @param header The http request header parameters.
 */
function getEbScenicSpotAreaId(areaId, header) {
    var url = "/board-api/eb_scenic/spot/" + areaId;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getEbScenicSpotAreaId = getEbScenicSpotAreaId;
/**
 * 精简字体测试
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getFont(query, header) {
    var url = "/board-api/font";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getFont = getFont;
/**
 * 获取所有有效大转盘活动Id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetAvailableActIds(query, header) {
    var url = "/board-api/lotteryDraw/getAvailableActIds";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetAvailableActIds = getLotteryDrawGetAvailableActIds;
/**
 * 获取有效活动
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetAvailableCheckOutActId(query, header) {
    var url = "/board-api/lotteryDraw/getAvailableCheckOutActId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetAvailableCheckOutActId = getLotteryDrawGetAvailableCheckOutActId;
/**
 * 获取有效大转盘活动
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetAvailableCheckOutCampaign(query, header) {
    var url = "/board-api/lotteryDraw/getAvailableCheckOutCampaign";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetAvailableCheckOutCampaign = getLotteryDrawGetAvailableCheckOutCampaign;
/**
 * 获取大转盘活动信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetCampaignInfo(query, header) {
    var url = "/board-api/lotteryDraw/getCampaignInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetCampaignInfo = getLotteryDrawGetCampaignInfo;
/**
 * 根据预售券订单号获取参与记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetCampaignLogBySaleOrderDetailId(query, header) {
    var url = "/board-api/lotteryDraw/getCampaignLogBySaleOrderDetailId";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetCampaignLogBySaleOrderDetailId = getLotteryDrawGetCampaignLogBySaleOrderDetailId;
/**
 * 获取活动个数
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetExistActNum(query, header) {
    var url = "/board-api/lotteryDraw/getExistActNum";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetExistActNum = getLotteryDrawGetExistActNum;
/**
 * （订单成功页）获取会员可参与的大转盘活动信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getLotteryDrawGetMemberCanPlayCampaignList(query, header) {
    var url = "/board-api/lotteryDraw/getMemberCanPlayCampaignList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getLotteryDrawGetMemberCanPlayCampaignList = getLotteryDrawGetMemberCanPlayCampaignList;
/**
 * 更新发券信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postLotteryDrawUpdateCampaignLogApiResultById(body, header) {
    var url = "/board-api/lotteryDraw/updateCampaignLogApiResultById";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postLotteryDrawUpdateCampaignLogApiResultById = postLotteryDrawUpdateCampaignLogApiResultById;
/**
 * 获取会员注册送礼所有生效的数据
 * @param header The http request header parameters.
 */
function getMemberRegisterGiftGetAllValidData(header) {
    var url = "/board-api/member_register_gift/get_all_valid_data";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getMemberRegisterGiftGetAllValidData = getMemberRegisterGiftGetAllValidData;
/**
 * 小工具设置默认首页
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisBoardHomePageBatchSave(body, header) {
    var url = "/board-api/mis/boardHomePage/batchSave";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisBoardHomePageBatchSave = postMisBoardHomePageBatchSave;
/**
 * 下载替换全局底部菜单栏结果数据（异步下载）
 * @param header The http request header parameters.
 */
function getMisCustomizeSnapshotHandleDownloadMenuJsonRecord(header) {
    var url = "/board-api/mis/customize_snapshot_handle/downloadMenuJsonRecord";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getMisCustomizeSnapshotHandleDownloadMenuJsonRecord = getMisCustomizeSnapshotHandleDownloadMenuJsonRecord;
/**
 * 获取全局底部菜单栏操作结果数据结果
 * @param key key
 * @param header The http request header parameters.
 */
function getMisCustomizeSnapshotHandleGetDownloadMenuJsonRecordLinkKey(key, header) {
    var url = "/board-api/mis/customize_snapshot_handle/getDownloadMenuJsonRecordLink/" + key;
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getMisCustomizeSnapshotHandleGetDownloadMenuJsonRecordLinkKey = getMisCustomizeSnapshotHandleGetDownloadMenuJsonRecordLinkKey;
/**
 * 通过数据url替换全局底部菜单栏数据
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomizeSnapshotHandleHandleMenuJsonByDataUrl(body, header) {
    var url = "/board-api/mis/customize_snapshot_handle/handleMenuJsonByDataUrl";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomizeSnapshotHandleHandleMenuJsonByDataUrl = postMisCustomizeSnapshotHandleHandleMenuJsonByDataUrl;
/**
 * 恢复方法（数据url替换全局底部菜单栏数据）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCustomizeSnapshotHandleRestoreHandleMenuJsonByDataUrl(query, header) {
    var url = "/board-api/mis/customize_snapshot_handle/restoreHandleMenuJsonByDataUrl";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCustomizeSnapshotHandleRestoreHandleMenuJsonByDataUrl = getMisCustomizeSnapshotHandleRestoreHandleMenuJsonByDataUrl;
/**
 * 恢复方法（数据url替换全局底部菜单栏数据）（单个）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCustomizeSnapshotHandleRestoreHandleMenuJsonRecord(query, header) {
    var url = "/board-api/mis/customize_snapshot_handle/restoreHandleMenuJsonRecord";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCustomizeSnapshotHandleRestoreHandleMenuJsonRecord = getMisCustomizeSnapshotHandleRestoreHandleMenuJsonRecord;
/**
 * 获取BALA付费模版列表接口，带开通状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCustomizeTemplatePermissionGetNeedPayTemplateList(query, header) {
    var url = "/board-api/mis/customize_template_permission/getNeedPayTemplateList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCustomizeTemplatePermissionGetNeedPayTemplateList = getMisCustomizeTemplatePermissionGetNeedPayTemplateList;
/**
 * 修改模版使用许可
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomizeTemplatePermissionSaveTemplateHotelPermission(body, header) {
    var url = "/board-api/mis/customize_template_permission/save_template_hotel_permission";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomizeTemplatePermissionSaveTemplateHotelPermission = postMisCustomizeTemplatePermissionSaveTemplateHotelPermission;
/**
 * 删除自定义实体字符接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisEntityCharacterDelete(query, header) {
    var url = "/board-api/mis/entity/character/delete";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisEntityCharacterDelete = getMisEntityCharacterDelete;
/**
 * 获取自定义实体字符列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisEntityCharacterGetList(body, header) {
    var url = "/board-api/mis/entity/character/getList";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisEntityCharacterGetList = postMisEntityCharacterGetList;
/**
 * 自定义实体字符保存接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisEntityCharacterSave(body, header) {
    var url = "/board-api/mis/entity/character/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisEntityCharacterSave = postMisEntityCharacterSave;
/**
 * 魔法画图优秀案例配置添加
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawCaseConfigAddOrModify(body, header) {
    var url = "/board-api/mis/magic/draw/case/config/addOrModify";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawCaseConfigAddOrModify = postMisMagicDrawCaseConfigAddOrModify;
/**
 * 魔法画图优秀案例配置删除
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawCaseConfigDelete(body, header) {
    var url = "/board-api/mis/magic/draw/case/config/delete";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawCaseConfigDelete = postMisMagicDrawCaseConfigDelete;
/**
 * 魔法画图优秀案例查询
 * @param header The http request header parameters.
 */
function postMisMagicDrawCaseConfigList(header) {
    var url = "/board-api/mis/magic/draw/case/config/list";
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postMisMagicDrawCaseConfigList = postMisMagicDrawCaseConfigList;
/**
 * 魔法画图优秀案例排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawCaseConfigSort(body, header) {
    var url = "/board-api/mis/magic/draw/case/config/sort";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawCaseConfigSort = postMisMagicDrawCaseConfigSort;
/**
 * 魔法画图主图配置添加
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawConfigAddOrModify(body, header) {
    var url = "/board-api/mis/magic/draw/config/addOrModify";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawConfigAddOrModify = postMisMagicDrawConfigAddOrModify;
/**
 * 魔法画图主图配置删除
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawConfigDelete(body, header) {
    var url = "/board-api/mis/magic/draw/config/delete";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawConfigDelete = postMisMagicDrawConfigDelete;
/**
 * 魔法画图主图配置枚举查询
 * @param header The http request header parameters.
 */
function postMisMagicDrawConfigFilter(header) {
    var url = "/board-api/mis/magic/draw/config/filter";
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postMisMagicDrawConfigFilter = postMisMagicDrawConfigFilter;
/**
 * 魔法画图主图配置查询
 * @param header The http request header parameters.
 */
function postMisMagicDrawConfigList(header) {
    var url = "/board-api/mis/magic/draw/config/list";
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postMisMagicDrawConfigList = postMisMagicDrawConfigList;
/**
 * 魔法画图主图配置排序
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawConfigSort(body, header) {
    var url = "/board-api/mis/magic/draw/config/sort";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawConfigSort = postMisMagicDrawConfigSort;
/**
 * 删除魔法绘图模型接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisMagicDrawModelDelete(query, header) {
    var url = "/board-api/mis/magic/draw/model/delete";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisMagicDrawModelDelete = getMisMagicDrawModelDelete;
/**
 * 获取魔法绘图模型详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisMagicDrawModelDetail(query, header) {
    var url = "/board-api/mis/magic/draw/model/detail";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisMagicDrawModelDetail = getMisMagicDrawModelDetail;
/**
 * 获取魔法绘图模型列表接口
 * @param header The http request header parameters.
 */
function getMisMagicDrawModelList(header) {
    var url = "/board-api/mis/magic/draw/model/list";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getMisMagicDrawModelList = getMisMagicDrawModelList;
/**
 * 保存魔法绘图模型接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawModelSave(body, header) {
    var url = "/board-api/mis/magic/draw/model/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawModelSave = postMisMagicDrawModelSave;
/**
 * 排序魔法绘图模型接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisMagicDrawModelSort(body, header) {
    var url = "/board-api/mis/magic/draw/model/sort";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisMagicDrawModelSort = postMisMagicDrawModelSort;
/**
 * 魔法绘图模型置顶接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisMagicDrawModelTop(query, header) {
    var url = "/board-api/mis/magic/draw/model/top";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisMagicDrawModelTop = getMisMagicDrawModelTop;
/**
 * 修改模版使用许可
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisSaveTemplateHotelPermission(body, header) {
    var url = "/board-api/mis/save_template_hotel_permission";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisSaveTemplateHotelPermission = postMisSaveTemplateHotelPermission;
/**
 * 修改首页模板JSON
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisUpdateHomepageJson(body, header) {
    var url = "/board-api/mis/update_homepage_json";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisUpdateHomepageJson = postMisUpdateHomepageJson;
/**
 * 切换是否付费模版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisUpdateTemplateNeedPay(body, header) {
    var url = "/board-api/mis/update_template_need_pay";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisUpdateTemplateNeedPay = postMisUpdateTemplateNeedPay;
/**
 * 删除店铺个性化配置接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCustomThemeDelete(query, header) {
    var url = "/board-api/mis_custom_theme/delete";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCustomThemeDelete = getMisCustomThemeDelete;
/**
 * 店铺个性化配置详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getMisCustomThemeGet(query, header) {
    var url = "/board-api/mis_custom_theme/get";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getMisCustomThemeGet = getMisCustomThemeGet;
/**
 * 店铺个性化配置列表接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomThemeList(body, header) {
    var url = "/board-api/mis_custom_theme/list";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomThemeList = postMisCustomThemeList;
/**
 * 保存店铺个性化配置接口
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomThemeSave(body, header) {
    var url = "/board-api/mis_custom_theme/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomThemeSave = postMisCustomThemeSave;
/**
 * 修改模版使用许可
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomizeTemplateSaveTemplateHotelPermission(body, header) {
    var url = "/board-api/mis_customize_template/save_template_hotel_permission";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomizeTemplateSaveTemplateHotelPermission = postMisCustomizeTemplateSaveTemplateHotelPermission;
/**
 * 切换是否付费模版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postMisCustomizeTemplateUpdateTemplateNeedPay(body, header) {
    var url = "/board-api/mis_customize_template/update_template_need_pay";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postMisCustomizeTemplateUpdateTemplateNeedPay = postMisCustomizeTemplateUpdateTemplateNeedPay;
/**
 * C端：通过站点id获取头尾导航列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getPcwebGetNavList(query, header) {
    var url = "/board-api/pcweb/getNavList";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getPcwebGetNavList = getPcwebGetNavList;
/**
 * C端pc官网获取新闻详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getPcwebGetNewsInfo(query, header) {
    var url = "/board-api/pcweb/getNewsInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getPcwebGetNewsInfo = getPcwebGetNewsInfo;
/**
 * C端获取页面详情接口
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getPcwebGetPageInfo(query, header) {
    var url = "/board-api/pcweb/getPageInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getPcwebGetPageInfo = getPcwebGetPageInfo;
/**
 * C端pc官网获取当前酒店的支付渠道信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getPcwebGetPayInfo(query, header) {
    var url = "/board-api/pcweb/getPayInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getPcwebGetPayInfo = getPcwebGetPayInfo;
/**
 * C端-站点：通过域名和目录获取对应的站点
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getPcwebGetWebsiteInfo(query, header) {
    var url = "/board-api/pcweb/getWebsiteInfo";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getPcwebGetWebsiteInfo = getPcwebGetWebsiteInfo;
/**
 * 未开售的产品的PVUV统计
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getProductInfoList(query, header) {
    var url = "/board-api/product/info_list";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getProductInfoList = getProductInfoList;
/**
 * 查询配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getRoomActivityBoardGet(query, header) {
    var url = "/board-api/roomActivity/Board/get";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getRoomActivityBoardGet = getRoomActivityBoardGet;
/**
 * 查询日历房活动标题列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postRoomActivityBoardGetRoomActivityTitleList(body, header) {
    var url = "/board-api/roomActivity/Board/getRoomActivityTitleList";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postRoomActivityBoardGetRoomActivityTitleList = postRoomActivityBoardGetRoomActivityTitleList;
/**
 * 通过titleType查询日历房活动标题列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postRoomActivityBoardGetRoomActivityTitleListByTitleType(body, header) {
    var url = "/board-api/roomActivity/Board/getRoomActivityTitleListByTitleType";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postRoomActivityBoardGetRoomActivityTitleListByTitleType = postRoomActivityBoardGetRoomActivityTitleListByTitleType;
/**
 * eb保存/更新配置
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postRoomActivityEbBoardSave(body, header) {
    var url = "/board-api/roomActivity/ebBoard/save";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postRoomActivityEbBoardSave = postRoomActivityEbBoardSave;
/**
 * 短信卖货商户版发送短信
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postSmsSellSendSms(body, header) {
    var url = "/board-api/smsSell/sendSms";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postSmsSellSendSms = postSmsSellSendSms;
/**
 * 获取海报系统图标列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getSystemIconListBoardSystemIcon(query, header) {
    var url = "/board-api/system_icon/list_board_system_icon";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getSystemIconListBoardSystemIcon = getSystemIconListBoardSystemIcon;
/**
 * 测试聚合海报迁移酒店维度
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestBoardInstanceToSnapshotByHotelTest(query, header) {
    var url = "/board-api/test/boardInstanceToSnapshot_by_hotel_test";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestBoardInstanceToSnapshotByHotelTest = postTestBoardInstanceToSnapshotByHotelTest;
/**
 * 测试聚合海报迁移海报维度
 * @param boardInstanceId 海报id
 * @param header The http request header parameters.
 */
function postTestBoardInstanceToSnapshotTestBoardInstanceId(boardInstanceId, header) {
    var url = "/board-api/test/boardInstanceToSnapshot_test/" + boardInstanceId;
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postTestBoardInstanceToSnapshotTestBoardInstanceId = postTestBoardInstanceToSnapshotTestBoardInstanceId;
/**
 * 测试红包的发放Feign
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestDeliverCoupon(body, header) {
    var url = "/board-api/test/deliver_coupon";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestDeliverCoupon = postTestDeliverCoupon;
/**
 * 测试 储值卡id转换 prepayCardClientFeign
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetTicketProductIdByPrepayCardProductIdTest(query, header) {
    var url = "/board-api/test/getTicketProductIdByPrepayCardProductId_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetTicketProductIdByPrepayCardProductIdTest = getTestGetTicketProductIdByPrepayCardProductIdTest;
/**
 * 聚合页生成海报
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestGetComposeTemplateNewTest(query, body, header) {
    var url = "/board-api/test/get_compose_template_new_test";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postTestGetComposeTemplateNewTest = postTestGetComposeTemplateNewTest;
/**
 * 聚合页生成海报
 * @param query The http request query parameters.
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestGetComposeTemplateOldTest(query, body, header) {
    var url = "/board-api/test/get_compose_template_old_test";
    return config_1.default.request({ url: url, method: 'post', query: query, body: body, header: header, });
}
exports.postTestGetComposeTemplateOldTest = postTestGetComposeTemplateOldTest;
/**
 * 测试红包Feign
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetCoupon(query, header) {
    var url = "/board-api/test/get_coupon";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetCoupon = getTestGetCoupon;
/**
 * 测试红包库存的缓存
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetCouponStockFromCache(query, header) {
    var url = "/board-api/test/get_coupon_stock_from_cache";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetCouponStockFromCache = getTestGetCouponStockFromCache;
/**
 * 测试 获取储值卡替换预售券
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestGetCurrentProductIdTickIdRelTest(body, header) {
    var url = "/board-api/test/get_current_productId_tickIdRel_test";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestGetCurrentProductIdTickIdRelTest = postTestGetCurrentProductIdTickIdRelTest;
/**
 * 测试 查询协议公司返现配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetHotelAreaByHotelIdListTest(query, header) {
    var url = "/board-api/test/get_hotel_area_by_hotel_id_list_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetHotelAreaByHotelIdListTest = getTestGetHotelAreaByHotelIdListTest;
/**
 * 测试 获取多个商户配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetHotelConfigListTest(query, header) {
    var url = "/board-api/test/get_hotel_config_list_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetHotelConfigListTest = getTestGetHotelConfigListTest;
/**
 * 测试 经过MIS开关获取的菜单结果
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetMisSwitchResultTest(query, header) {
    var url = "/board-api/test/get_mis_switch_result_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetMisSwitchResultTest = getTestGetMisSwitchResultTest;
/**
 * 测试 根据集团酒店查询自营酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetSelfHotelIdByBrandIdsTest(query, header) {
    var url = "/board-api/test/get_self_hotelId_by_brandIds_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetSelfHotelIdByBrandIdsTest = getTestGetSelfHotelIdByBrandIdsTest;
/**
 * 测试 业务特殊配置获取
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestGetSprcialConfigTest(query, header) {
    var url = "/board-api/test/get_sprcial_config_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestGetSprcialConfigTest = getTestGetSprcialConfigTest;
/**
 * 测试校验
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestGetTest2(body, header) {
    var url = "/board-api/test/get_test2";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestGetTest2 = postTestGetTest2;
/**
 * 清洗自定义页面链接数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestLinkedDataTest(query, header) {
    var url = "/board-api/test/linked_data_test";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestLinkedDataTest = postTestLinkedDataTest;
/**
 * 测试 list_product_commission
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestListProductCommissionTest(body, header) {
    var url = "/board-api/test/list_product_commission_test";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestListProductCommissionTest = postTestListProductCommissionTest;
/**
 * 测试红包领取记录查询Feign
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestMarketingCouponInfo(body, header) {
    var url = "/board-api/test/marketing_coupon_info";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestMarketingCouponInfo = postTestMarketingCouponInfo;
/**
 * 测试 对某一自定义页面转换储值卡id
 * @param customizeSnapshotId customizeSnapshotId
 * @param header The http request header parameters.
 */
function postTestReplaceProductSidTestCustomizeSnapshotId(customizeSnapshotId, header) {
    var url = "/board-api/test/replace_product_sid_test/" + customizeSnapshotId;
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postTestReplaceProductSidTestCustomizeSnapshotId = postTestReplaceProductSidTestCustomizeSnapshotId;
/**
 * testApollo
 * @param header The http request header parameters.
 */
function getTestTestApollo(header) {
    var url = "/board-api/test/test_apollo";
    return config_1.default.request({ url: url, method: 'get', header: header, });
}
exports.getTestTestApollo = getTestTestApollo;
/**
 * getDeliverConfig
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestTestCacheGetDeliverConfig(query, header) {
    var url = "/board-api/test/test_cache/get_deliverConfig";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestTestCacheGetDeliverConfig = getTestTestCacheGetDeliverConfig;
/**
 * getHotelForTestCache
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestTestCacheGetHotel(query, header) {
    var url = "/board-api/test/test_cache/get_hotel";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestTestCacheGetHotel = getTestTestCacheGetHotel;
/**
 * deleteCityForTestCache
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache01DeleteCity(query, header) {
    var url = "/board-api/test/test_cache01/delete_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache01DeleteCity = postTestTestCache01DeleteCity;
/**
 * getCityForTestCache
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestTestCache01GetCity(query, header) {
    var url = "/board-api/test/test_cache01/get_city";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestTestCache01GetCity = getTestTestCache01GetCity;
/**
 * updateCityForTestCache
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache01UpdateCity(query, header) {
    var url = "/board-api/test/test_cache01/update_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache01UpdateCity = postTestTestCache01UpdateCity;
/**
 * deleteCityForTestCache2
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache02DeleteCity(query, header) {
    var url = "/board-api/test/test_cache02/delete_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache02DeleteCity = postTestTestCache02DeleteCity;
/**
 * getCityForTestCache2
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestTestCache02GetCity(query, header) {
    var url = "/board-api/test/test_cache02/get_city";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestTestCache02GetCity = getTestTestCache02GetCity;
/**
 * updateCityForTestCache2
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache02UpdateCity(query, header) {
    var url = "/board-api/test/test_cache02/update_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache02UpdateCity = postTestTestCache02UpdateCity;
/**
 * deleteCityForTestCache3
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache03DeleteCity(query, header) {
    var url = "/board-api/test/test_cache03/delete_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache03DeleteCity = postTestTestCache03DeleteCity;
/**
 * getCityForTestCache3
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestTestCache03GetCity(query, header) {
    var url = "/board-api/test/test_cache03/get_city";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestTestCache03GetCity = getTestTestCache03GetCity;
/**
 * updateCityForTestCache3
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function postTestTestCache03UpdateCity(query, header) {
    var url = "/board-api/test/test_cache03/update_city";
    return config_1.default.request({ url: url, method: 'post', query: query, header: header, });
}
exports.postTestTestCache03UpdateCity = postTestTestCache03UpdateCity;
/**
 * 测试 修改首页模板JSON
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
function postTestUpdateHomepageJsonTest(body, header) {
    var url = "/board-api/test/update_homepage_json_test";
    return config_1.default.request({ url: url, method: 'post', body: body, header: header, });
}
exports.postTestUpdateHomepageJsonTest = postTestUpdateHomepageJsonTest;
/**
 * 校验appId 和 hotelId 关系测试
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
function getTestValidateHotelAndAppTest(query, header) {
    var url = "/board-api/test/validateHotelAndApp_test";
    return config_1.default.request({ url: url, method: 'get', query: query, header: header, });
}
exports.getTestValidateHotelAndAppTest = getTestValidateHotelAndAppTest;
/**
 * 上传文件，返回路径
 * @param header The http request header parameters.
 */
function postUploadUploadVideo(header) {
    var url = "/board-api/upload/uploadVideo";
    return config_1.default.request({ url: url, method: 'post', header: header, });
}
exports.postUploadUploadVideo = postUploadUploadVideo;
//#endregion
